<!-- 
      *-----bnpl-site-msite ----
      *This web page loaded in the mobile app as the Shopping tab.
      *Developed by Koko Tech.

      @author Ushan Alwis 
      @Latest-Version 2.0.15 
      @Latest-Commited-Date 2022.08.22
  -->
  <template>
    <!-- <div class="snowflakes" aria-hidden="true"> -->
    <!-- <div class="snowflake">
        <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/pumpkin_25ec5c38cc.png?updated_at=2023-10-15T03:16:19.383Z" alt="" style="width: 30px;height: 30px;" >                
      </div>
      <div class="snowflake">
        <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/witch_213cb176ca.png?updated_at=2023-10-15T03:16:19.281Zg" alt="" style="width: 30px;height: 30px;" >                
      </div>
      <div class="snowflake">
        <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/costume_4c6c6c468f.png?updated_at=2023-10-15T03:16:18.853Z" alt="" style="width: 30px;height: 30px;" >                
      </div>
      <div class="snowflake">
        <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/ghost_9aa977db0d.png?updated_at=2023-10-15T03:16:18.773Z" alt="" style="width: 30px;height: 30px;" >                
      </div>
      <div class="snowflake">
        <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/pumpkin_25ec5c38cc.png?updated_at=2023-10-15T03:16:19.383Z" alt="" style="width: 30px;height: 30px;" >                
      </div>
      <div class="snowflake">
        <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/witch_213cb176ca.png?updated_at=2023-10-15T03:16:19.281Zg" alt="" style="width: 30px;height: 30px;" >                
      </div>
      <div class="snowflake">
        <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/costume_4c6c6c468f.png?updated_at=2023-10-15T03:16:18.853Z" alt="" style="width: 30px;height: 30px;" >                
      </div>
      <div class="snowflake">
        <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/ghost_9aa977db0d.png?updated_at=2023-10-15T03:16:18.773Z" alt="" style="width: 30px;height: 30px;" >                
      </div>
      <div class="snowflake">
        <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/pumpkin_25ec5c38cc.png?updated_at=2023-10-15T03:16:19.383Z" alt="" style="width: 30px;height: 30px;" >                
      </div>
      <div class="snowflake">
        <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/witch_213cb176ca.png?updated_at=2023-10-15T03:16:19.281Zg" alt="" style="width: 30px;height: 30px;" >                
      </div>
      <div class="snowflake">
        <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/costume_4c6c6c468f.png?updated_at=2023-10-15T03:16:18.853Z" alt="" style="width: 30px;height: 30px;" >                
      </div>
      <div class="snowflake">
        <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/ghost_9aa977db0d.png?updated_at=2023-10-15T03:16:18.773Z" alt="" style="width: 30px;height: 30px;" >                
      </div> -->
  
    <!-- <div class="snowflake">
        <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/Kawili_8_815721898e.png?updated_at=2023-04-06T12:54:19.359Z" alt="" style="width: 30px;height: 30px;" >                
      </div>
      <div class="snowflake">
        <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/Kawili_2_98db03bcb4.png?updated_at=2023-04-06T12:54:19.468Z" alt="" style="width: 30px;height: 30px;" >                
      </div>
      <div class="snowflake">
        <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/Kawili_4_037d13897d.png?updated_at=2023-04-06T12:54:21.313Z" alt="" style="width: 30px;height: 30px;" >                
      </div>
      <div class="snowflake">
        <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/Kawili_1_58e59b27c9.png?updated_at=2023-04-06T12:30:50.933Z" alt="" style="width: 30px;height: 30px;" >                
      </div>
      <div class="snowflake">
        <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/Kawili_6_69eaaa4ae3.png?updated_at=2023-04-06T12:54:19.936Z" alt="" style="width: 30px;height: 30px;" >                
      </div>
      <div class="snowflake">
        <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/Kawili_8_815721898e.png?updated_at=2023-04-06T12:54:19.359Z" alt="" style="width: 30px;height: 30px;" >                
      </div>
      <div class="snowflake">
        <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/Kawili_10_a2f4b07073.png?updated_at=2023-04-06T12:54:18.617Z" alt="" style="width: 30px;height: 30px;" >                
      </div>
      <div class="snowflake">
        <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/Kawili_9_86f08bc2d9.png?updated_at=2023-04-06T12:54:18.588Z" alt="" style="width: 30px;height: 30px;" >                
      </div>
      <div class="snowflake">
        <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/Kawili_8_815721898e.png?updated_at=2023-04-06T12:54:19.359Z" alt="" style="width: 30px;height: 30px;" >                
      </div>
      <div class="snowflake">
        <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/Kawili_2_98db03bcb4.png?updated_at=2023-04-06T12:54:19.468Z" alt="" style="width: 30px;height: 30px;" >                
      </div>
      <div class="snowflake">
        <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/Kawili_4_037d13897d.png?updated_at=2023-04-06T12:54:21.313Z" alt="" style="width: 30px;height: 30px;" >                
      </div>
      <div class="snowflake">
        <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/Kawili_1_58e59b27c9.png?updated_at=2023-04-06T12:30:50.933Z" alt="" style="width: 30px;height: 30px;" >                
      </div>
      <div class="snowflake">
        <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/Kawili_6_69eaaa4ae3.png?updated_at=2023-04-06T12:54:19.936Z" alt="" style="width: 30px;height: 30px;" >                
      </div>
      <div class="snowflake">
        <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/Kawili_8_815721898e.png?updated_at=2023-04-06T12:54:19.359Z" alt="" style="width: 30px;height: 30px;" >                
      </div>
      <div class="snowflake">
        <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/Kawili_10_a2f4b07073.png?updated_at=2023-04-06T12:54:18.617Z" alt="" style="width: 30px;height: 30px;" >                
      </div>
      <div class="snowflake">
        <img src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/Kawili_9_86f08bc2d9.png?updated_at=2023-04-06T12:54:18.588Z" alt="" style="width: 30px;height: 30px;" >                
      </div> -->
  
    <!-- <div class="snowflake">❆</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❅</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❅</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❅</div>
      <div class="snowflake">❅</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❅</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❅</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❅</div>
      <div class="snowflake">❅</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❅</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❅</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❅</div>
      <div class="snowflake">❅</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❅</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❅</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❅</div>
      <div class="snowflake">❅</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❅</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❅</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❅</div>
      <div class="snowflake">❅</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❅</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❅</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❅</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❅</div>
      <div class="snowflake">❅</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❅</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❅</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❆</div>
      <div class="snowflake">❅</div>
      <div class="snowflake">❅</div> -->
    <!-- </div> -->
    <div
      class="container"
      style="text-align: left; padding-top: 15px; z-index: -999999"
    >
      <!-- <table style="width: 100%">
        <tr style="width: 100%">
          <td style="width: 100%">
            <div class="searchBar" @click="triggerDrawer">
              <div class="searchBox">
                <div class="searchText">
                  Search for a store
  
                  <svg
                    style="
                      width: 24px;
                      height: 19px;
                      float: right;
                      margin-right: 8%;
                    "
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="#666666"
                      d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </table> -->
  
      <div class="search-box-input" @click="triggerDrawer">
        <div class="search-box-input-child" />
        <div class="user-interface-magnifier-wrapper" >
          <img
            class="user-interface-magnifier"
            loading="eager"
            alt="searcg"
            src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Koko-search/searchBar-search-icon.png"
          />
        </div>
        <div class="search-box-label">
          
          <b class="try-our-new">Find your fav stores here!</b>
          <div class="user-interface-fire-wrapper">
          <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M5.64518 5.24658L5.64368 5.24772L5.64225 5.24902L5.64518 5.24658ZM12.2813 5.13C12.2349 5.08809 12.1834 5.05142 12.1279 5.02074C12.0494 4.9774 11.9622 4.94963 11.8717 4.93914C11.7813 4.92865 11.6895 4.93566 11.6021 4.95975C11.5146 4.98383 11.4334 5.02447 11.3634 5.07916C11.2933 5.13385 11.236 5.20143 11.195 5.2777C10.9653 5.70189 10.6486 6.07938 10.263 6.38854C10.3219 6.07704 10.3517 5.7613 10.3518 5.44493C10.3531 4.4825 10.0823 3.53694 9.56695 2.70454C9.05164 1.87213 8.31024 1.18261 7.41825 0.706185C7.31999 0.653964 7.20919 0.626003 7.09624 0.624926C6.9833 0.623848 6.87191 0.649689 6.77253 0.700023C6.67316 0.750358 6.58905 0.823536 6.52811 0.912691C6.46716 1.00185 6.43138 1.10406 6.42411 1.20973C6.3868 1.80234 6.22155 2.38168 5.93837 2.91264C5.65519 3.44361 5.25997 3.91516 4.77666 4.2987L4.62302 4.41589C4.11763 4.7347 3.67028 5.1277 3.29815 5.57983C2.71969 6.26302 2.31898 7.06317 2.12779 7.91682C1.9366 8.77046 1.96018 9.65413 2.19668 10.4977C2.43318 11.3414 2.87608 12.1217 3.49026 12.7769C4.10445 13.4321 4.87302 13.9442 5.73502 14.2725C5.83624 14.3112 5.94607 14.3261 6.05484 14.3156C6.16361 14.3052 6.26797 14.2698 6.35871 14.2127C6.44946 14.1555 6.5238 14.0782 6.57518 13.9878C6.62656 13.8973 6.6534 13.7963 6.65333 13.6938C6.65285 13.6275 6.64166 13.5617 6.62013 13.4985C6.47098 12.9729 6.42803 12.4258 6.4935 11.8854C7.12432 13.0008 8.13692 13.885 9.3685 14.3957C9.51883 14.4588 9.68877 14.4673 9.84539 14.4196C10.8184 14.1251 11.695 13.6023 12.3918 12.9008C13.0886 12.1993 13.5826 11.3425 13.8266 10.4116C14.0707 9.48077 14.0569 8.50686 13.7864 7.58245C13.5159 6.65803 12.9978 5.81381 12.2813 5.13ZM9.67806 13.1494C9.09694 12.8733 8.5843 12.4856 8.17349 12.0116C7.76268 11.5375 7.4629 10.9877 7.29362 10.3979C7.24192 10.1994 7.20193 9.99824 7.17383 9.79553C7.15478 9.66644 7.09318 9.54615 6.99764 9.45149C6.9021 9.35683 6.77739 9.29252 6.64095 9.26757C6.59892 9.2598 6.55617 9.25592 6.51333 9.25598C6.39616 9.25594 6.28105 9.28487 6.17961 9.33984C6.07816 9.39481 5.99397 9.47389 5.93553 9.5691C5.38238 10.4636 5.1042 11.4841 5.13182 12.5177C4.64531 12.1631 4.23872 11.7215 3.9356 11.2185C3.63249 10.7154 3.43888 10.161 3.366 9.58733C3.29312 9.01365 3.34242 8.43211 3.51103 7.87641C3.67965 7.32072 3.96423 6.80193 4.34829 6.35011C4.6399 5.99501 4.99168 5.68717 5.38963 5.43886C5.40686 5.42843 5.42338 5.41702 5.4391 5.40468C5.4391 5.40468 5.6369 5.25125 5.64366 5.24774C6.59346 4.49459 7.269 3.48244 7.57615 2.35231C8.30253 2.98183 8.78688 3.81858 8.95399 4.73263C9.1211 5.64668 8.96161 6.58688 8.5003 7.40724C8.43936 7.51671 8.41436 7.64065 8.42845 7.76342C8.44255 7.8862 8.49512 8.00231 8.57952 8.09711C8.66392 8.19191 8.77638 8.26115 8.90271 8.2961C9.02904 8.33105 9.16358 8.33014 9.28936 8.29349C10.3106 7.99339 11.2092 7.40719 11.8642 6.6138C12.2579 7.15899 12.5153 7.78044 12.6172 8.43184C12.7191 9.08325 12.6629 9.74781 12.4528 10.376C12.2427 11.0042 11.884 11.5799 11.4036 12.0601C10.9231 12.5403 10.3333 12.9126 9.67804 13.1494L9.67806 13.1494Z" fill="#F486E3"/>
  </svg>
        </div>
        </div>
        
      </div>
  
      <SearchDrawer :closeSearchDrawer="closeSearchDrawer" :drawerVisible="drawerVisible" />  
  
      <div
        class="drawer-mask"
        :style="{
          width: drawerVisible ? '100vw' : '0',
          opacity: drawerVisible ? '0.6' : '0',
        }"
        @click="drawerVisible = false"
      ></div>
  
      <!-- Countdown Section Started -->
      <div class="row mt-3" style="display: none">
        <div class="container">
          <div class="promotion_countdown_center4">
            <a href="#">
              <div class="row">
                <div class="col-4">
                  <div style="margin-left: 5%; margin-top: 55%"></div>
                </div>
                <div class="col-8">
                  <div class="countdown" style="margin-top: 9%">
                    <div class="countdown-item">
                      <span id="day">-</span>
                      <span style="font-size: 10px">Day</span>
                    </div>
  
                    <div class="countdown-item">
                      <span id="hour">-</span>
                      <span style="font-size: 10px">Hours</span>
                    </div>
  
                    <div class="countdown-item">
                      <span id="minute">-</span>
                      <span style="font-size: 10px">Minutes</span>
                    </div>
  
                    <div class="countdown-item">
                      <span id="second">-</span>
                      <span style="font-size: 10px">Seconds</span>
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <!-- Countdown Section End -->
  
      <!-- <div class="row" style="" v-if="showTopModuleData"></div> -->
  
      <!-- Main Carousel slider starts -->
      <div
        class="mt-1"
        style="width: 100%; margin-bottom: 20px"
        v-if="showBanners"
      >
        <Splide :options="options">
          <SplideSlide v-for="(banners, index) in heroBannersList" :key="banners.id">
            <a :href="banners.heroBannerLink">
              <img
              :src="`${banners.heroBanner.url}`"
              :srcset="`
                ${banners.heroBanner.url}?image_process=resize,w_200 200w,
                ${banners.heroBanner.url}?image_process=resize,w_400 400w,
                ${banners.heroBanner.url}?image_process=resize,w_800 800w,
                ${banners.heroBanner.url}?image_process=resize,w_1200 1200w
              `"
              loading="eager"
              :fetchpriority="index === 0 ? 'high' : 'auto'"
              sizes="(max-width: 480px) 200px, (max-width: 768px) 400px, (max-width: 1024px) 800px, 1200px"
              alt="Banner"
              style="width: 100%; height: auto; border-radius: 20px; transition: 0.3s;"
            />
            </a>
          </SplideSlide>
        </Splide>
      </div>
      <div style="width: 100%; margin-bottom: 10px" v-if="showSkelton">
        <div class="skeleton">
          <div class="s-img"></div>
        </div>
      </div>
      <!-- Main Carousel slider Ends -->
  
      <!-- Category Section Start -->
      <div class="categories">
        <div class="scrollmenu">
          <ul class="cat-list">
            <li
              class="nav-item cat-item"
              role="presentation"
              v-for="items in homePageCategoriesFilteredData"
              :key="items.id"
              :style="{
                backgroundColor: this.categoryBgColor,
              }"
            >
              <router-link
                :to="'/m/category?cattype=' + items.Slug"
                class="cat-item-text"
              >
                <!-- <img
                  :src="items.CategoryImage.formats.thumbnail.url"
                  style="width: 90%; text-align: center; border-radius: 50%;"
                /> -->
                <div
                  style="font-size: 10pt"
                  :style="{
                    color: this.categoryFontColor,
                  }"
                >
                  {{ items.CategoryName }}
                </div>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <!-- Category Section End -->
      <!-- Featured Stores Start -->
      <div class="feture_stores">
        <div class="sectionHead" style="margin-top: 5px !important">
          <span>{{ this.onsiteSettings.featured_stores_title }}</span>
          <span v-if="this.featuredStoresIcon">
            <img
              :src="this.featuredStoresIcon"
              alt="“featured-store-icon”"
              style="height: 30px; margin-left: 10px; margin-top: -10px"
            />
          </span>
        </div>
        <div class="mx-2">
          <div class="row">
            <div class="fashion_body">
              <section>
                <div class="cards-wrapper3" style="margin-left: -10px">
                  <div
                    class="card5"
                    style="padding-right: 10px; position: relative"
                    v-for="items in FeaturedStores"
                    :key="items.id"
                  >
                    <router-link
                      :to="'/m/merchant/' + items.id"
                      style="text-decoration: none; font-weight: bold"
                    >
                      <div class="badge">{{ items.merchantDiscount }}</div>
                      <div class="badge3" v-if="items.merchant_types.length > 0">
                        <span>
                          <img
                            src="@/assets/images/shopping-bag.png"
                            alt="“merchant-type-logo”"
                            height="10"
                            loading="eager"
                            style="margin-right: 2px; margin-top: -2px"
                          />
                        </span>
                        <span
                          class="bg animated fadeInDown"
                          style="color: #000000"
                          v-for="type in items.merchant_types"
                          :key="type.id"
                          >{{ type.Type }}
                          <span
                            v-if="type != items.merchant_types.slice(-1)[0]"
                            style="padding-left: 2px"
                            >|</span
                          >
                        </span>
                      </div>
                      <img
                        :src="items.rectBubbleUrl.url"
                        loading="eager"
                        style="
                          width: 100%;
                          height: 150px;
                          text-align: center;
                          border-radius: 16px;
                        "
                      />
                    </router-link>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
      <!-- Featured Stores End -->
  
      <!-- Home Page Modules Start - First Line-->
      <div class="row" style="margin-bottom: 5%" v-if="showTopModuleLoader">
        <div class="col-4" style="text-align: center; border: 0px solid">
          <div class="card4">
            <div class="cover skeleton2" style="margin-bottom: 10%"></div>
          </div>
        </div>
  
        <div class="col-4" style="text-align: center; border: 0px solid">
          <div class="card4">
            <div class="cover skeleton2" style="margin-bottom: 10%"></div>
          </div>
        </div>
        <div class="col-4" style="text-align: center; border: 0px solid">
          <div class="card4">
            <div class="cover skeleton2" style="margin-bottom: 10%"></div>
          </div>
        </div>
      </div>
  
      <div
        class="row module_row"
        style="margin-bottom: 5%"
        v-if="showTopModuleData"
      >
        <div
          class="col-3"
          style="text-align: center; border: 0px solid; margin-top: 5%"
          v-for="items in firstLine"
          :key="items.Module_Order_ID"
        >
          <a
            :href="'/m/' + items.slug"
            style="text-decoration: none; color: #282828; font-weight: bold"
          >
            <div
              style="background-color: #f5eee8; border-radius: 16px; height: 86%"
            >
            <img
              :src="items.Module_Image.url"
              :srcset="`
                ${items.Module_Image.url}?image_process=resize,w_200 200w,
                ${items.Module_Image.url}?image_process=resize,w_400 400w,
                ${items.Module_Image.url}?image_process=resize,w_800 800w,
                ${items.Module_Image.url}?image_process=resize,w_1200 1200w
              `"
                sizes="(max-width: 480px) 200px, (max-width: 768px) 400px, (max-width: 1024px) 800px, 1200px"
                loading="eager"
                alt="Module Image"
                style="
                  width: 100%;
                  border-radius: 16px;
                  height: auto;
                  object-fit: cover;
                "
              />
            </div>
            <div style="font-size: 10px">
              {{ items.Module_Name }}
            </div>
          </a>
        </div>
      </div>
      <!-- Home Page Modules Start - First Line-->
  
      <!-- Hot Deals sections starts -->
      <div class="feture_stores" v-if="showHotDeals">
        <div class="sectionHead">
          <span>{{ this.onsiteSettings.hot_deals_title }}</span>
          <span v-if="this.hotDealsIcon"
            ><img
              :src="this.hotDealsIcon"
              alt="“hot-deals-icon"
              style="height: 30px; margin-left: 10px; margin-top: -10px"
            />
          </span>
        </div>
        <div class="mx-2">
          <div class="row">
            <div class="fashion_body">
              <section>
                <div class="cards-wrapper3" style="margin-left: -10px">
                  <div
                    class="card5"
                    style="padding-right: 10px; position: relative"
                    v-for="items in hotDealsMerchants"
                    :key="items.Rank"
                  >
                    <router-link
                      :to="'/m/merchant/' + items.Merchant_Id"
                      style="text-decoration: none; font-weight: bold"
                    >
                      <div class="badge">{{ items.Merchant_Discount }}</div>
                      <div class="badge3" v-if="items.merchant_types.length > 0">
                        <span>
                          <img
                            src="@/assets/images/shopping-bag.png"
                            alt="“merchant-type-logo”"
                            height="10"
                            style="margin-right: 2px; margin-top: -2px"
                          />
                        </span>
                        <span
                          class="bg animated fadeInDown"
                          style="color: #000000"
                          v-for="type in items.merchant_types"
                          :key="type.id"
                          >{{ type.Type }}
                          <span
                            v-if="type != items.merchant_types.slice(-1)[0]"
                            style="padding-left: 2px"
                            >|</span
                          >
                        </span>
                      </div>
                      <img
                        :src="items.Merchant_Thumbnail.url"
                        style="
                          width: 100%;
                          height: 150px;
                          text-align: center;
                          border-radius: 16px;
                        "
                      />
                    </router-link>
                  </div>
                </div>
  
                <div class="cards-wrapper3-skeleton" v-if="loadHotDeals">
                  <div class="card4">
                    <div class="cover skeleton" style="margin-bottom: 10%"></div>
                  </div>
                  <div class="card4">
                    <div class="cover skeleton" style="margin-bottom: 10%"></div>
                  </div>
                  <div class="card4">
                    <div class="cover skeleton" style="margin-bottom: 10%"></div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
      <!-- Hot Deals section ends -->
  
      <!-- Hot Products section -->
      <div class="hot_deals" v-if="hotproducts">
        <div class="row mt-2">
          <div class="d-flex justify-content-between">
            <div class="col-9">
              <div class="sectionHead">
                <span>{{ this.onsiteSettings.hot_products_title }}</span>
                <span v-if="this.hotproductsIcon"
                  ><img
                    :src="this.hotproductsIcon"
                    alt="“hot-products-icon”"
                    style="height: 30px; margin-left: 10px; margin-top: -10px"
                /></span>
              </div>
            </div>
            <!-- <div class="snowIcon"> -->
            <!-- <img src="@/assets/images/snowflake.gif" alt=“logo-grey” style="height: 30px;"> -->
  
            <!-- <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div>
              <div class="particle"></div> -->
            <!-- </div> -->
            <router-link
              to="/m/products"
              style="text-decoration: none; font-weight: bold"
            >
              <p class="sectionSubs">View All</p>
            </router-link>
          </div>
        </div>
  
        <div class="hotdeals_body">
          <section style="margin-left: 5%; margin-right: 2%">
            <div class="cards-wrapper">
              <div class="card" v-for="items in this.ProductList" :key="items.id">
                <a :href="items.productLink">
                  <div>
                    <img
                      :src="items.productBanner.formats.thumbnail.url"
                      style="width: 100%; border-radius: 16px"
                    />
  
                    <div class="discount">
                      <div class="discount-text">
                        <span>{{ items.productPrice }}</span>
                      </div>
                    </div>
  
                    <p class="mercText">{{ items.productName }}</p>
                  </div>
                </a>
              </div>
            </div>
          </section>
          <div
            class="sectionBody2"
            style="
              margin-left: 6%;
              padding-top: 5px;
              text-align: left;
              margin-right: 10px;
              padding-bottom: 10px;
              display: none;
            "
          >
            Offers Valid on 27th to 29th of May
          </div>
        </div>
      </div>
      <!-- Hot Products section End -->
  
      <!-- Strip Banner  -->
      <div class="row mt-3" v-if="stripBanner">
        <Splide :options="stripBanner_options">
          <SplideSlide v-for="items in stripBannerList" :key="items.id">
            <a :href="items.BannerLink">
              <img
              :src="items.bannerUpload.formats.small.url"
              :srcset="`
                ${items.bannerUpload.formats.small.url} 320w,
                ${items.bannerUpload.formats.medium.url} 640w,
                ${items.bannerUpload.formats.large.url} 1280w
              `"
              sizes="(max-width: 480px) 320px, (max-width: 768px) 640px, 1280px"
              width="640" 
              height="480"
              loading="lazy"
              alt="Sample 1"
              style="
                height: auto;
                width: 100%;
                border-radius: 16px;
                box-shadow: 0px 4px 8px rgba(221, 11, 126, 0.34);
                transition: 0.3s;
                object-fit: cover;
              "
            />

            </a>
          </SplideSlide>
        </Splide>
      </div>
      <!-- Strip Banner Ends -->
  
      <!-- Cluster Banner Starts -->
      <div class="fashion_body">
        <div class="row mt-3 cluster_row">
          <div class="col-5" style="position: relative">
            <div class="container_cluster">
              <!-- First Cluster Banner -->
              <div class="cluster1-badge">
                {{ this.firstClusterBanner.Cluster_Discount }}
              </div>
              <div class="cluster_background_image">
                <div
                  v-if="!this.firstClusterImage"
                  class="skeleton"
                  style="height: 100%"
                >
                  <div class="s-img"></div>
                </div>
                <img
                  v-else
                  :src="this.firstClusterImage"
                  style="width: 100%; height: 100%; border-radius: 20px"
                />
              </div>
              <a :href="this.firstClusterBanner.Cluster_URL">
                <div class="cluster_icon">
                  <img
                    src="https://prod-site-cdn.paykoko.com/cluster_next_df0c8d3071.png?updated_at=2023-11-17T06:31:45.908Z"
                    style="width: 20px"
                  />
                </div>
              </a>
            </div>
          </div>
          <div class="col-7" style="position: relative">
            <div class="container_cluster">
              <!-- Second Cluster Banner -->
              <div class="cluster2-badge">
                {{ this.secondClusterBanner.Cluster_Desc }}
              </div>
              <div class="cluster_background_image">
                <div
                  v-if="!this.secondClusterImage"
                  class="skeleton"
                  style="height: 100%"
                >
                  <div class="s-img"></div>
                </div>
                <img
                  v-else
                  :src="this.secondClusterImage"
                  :srcset="`
                    ${this.secondClusterImage}?image_process=resize,w_200 200w,
                    ${this.secondClusterImage}?image_process=resize,w_400 400w,
                    ${this.secondClusterImage}?image_process=resize,w_800 800w,
                    ${this.secondClusterImage}?image_process=resize,w_1200 1200w
                  `"
                   sizes="(max-width: 480px) 200px, (max-width: 768px) 400px, (max-width: 1024px) 800px, 1200px"
                   style="
                    width: 100%;
                    height: 100%;
                    border-radius: 20px;
                    padding-left: -12px;
                  "
                  alt="cluster-image"
                />
              </div>
              <a :href="this.secondClusterBanner.Cluster_URL">
                <div class="cluster_icon">
                  <img
                    src="https://prod-site-cdn.paykoko.com/cluster_next_df0c8d3071.png?updated_at=2023-11-17T06:31:45.908Z"
                    style="width: 20px"
                  />
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- Cluster Banner Ends -->
  
      <!-- Bottom Leaderboard Banner  -->
      <div class="row mt-3" v-if="leadership_banner">
        <Splide :options="Leaderboard_BannerOptions">
          <SplideSlide v-for="items in secondaryHeroBanners" :key="items.id">
            <a :href="items.Banner_Link">
              <img
                :src="items.Banner_Image.formats.small.url"
                alt="Sample 1"
                style="height:100%;width: 100%;border-radius: 16px; rgb(221 11 126 / 34%) 0px 4px 8px 0px;transition: 0.3s;"
              />
            </a>
          </SplideSlide>
        </Splide>
      </div>
      <!-- Bottom Leaderboard Banner Ends -->
  
      <!-- Created for you section -->
      <div class="fashions" v-if="inspirationList">
        <div class="row">
          <div class="col-9">
            <div class="sectionHead">
              {{ this.onsiteSettings.InspirationalList_Name }}
            </div>
          </div>
          <div class="col-3">
            <router-link
              to="/m/foryou?type=all&title=All Products"
              style="text-decoration: none; font-weight: bold"
            >
              <p class="sectionSubs">View All</p>
            </router-link>
          </div>
        </div>
  
        <div class="fashion_body2">
          <section style="margin-left: 5%; margin-right: 2%">
            <div class="cards-wrapper3">
              <div
                class="card3"
                v-for="inspiratinalList in InspirationalListThumbnails"
                :key="inspiratinalList.id"
              >
                <a
                  :href="
                    '/m/foryou?type=' +
                    inspiratinalList.slug +
                    '&title=' +
                    inspiratinalList.Category_Name
                  "
                  style="text-decoration: none; font-weight: bold"
                >
                  <img
                    :src="inspiratinalList.Thumbnail_Image.url"
                    :srcset="`
                    ${inspiratinalList.Thumbnail_Image.url}?image_process=resize,w_200 200w,
                    ${inspiratinalList.Thumbnail_Image.url}?image_process=resize,w_400 400w,
                    ${inspiratinalList.Thumbnail_Image.url}?image_process=resize,w_800 800w,
                    ${inspiratinalList.Thumbnail_Image.url}?image_process=resize,w_1200 1200w
                    `"
                   sizes="(max-width: 480px) 200px, (max-width: 768px) 400px, (max-width: 1024px) 800px, 1200px"
                    style="width: 100%; text-align: center;border-radius:16px;rgb(223 189 162 / 52%) 0px 8px 8px -4px;"
                  />
                </a>
              </div>
            </div>
          </section>
        </div>
      </div>
      <!-- Created for you section End-->
  
      <!-- Top Electronics -->
      <div class="fashions">
        <div class="row mt-3">
          <div class="d-flex justify-content-between">
            <div class="sectionHead">Top Electronics</div>
            <router-link
              to="/m/category?cattype=electronics"
              style="text-decoration: none; font-weight: bold"
            >
              <p class="sectionSubs">View All</p>
            </router-link>
          </div>
        </div>
  
        <div class="fashion_body mt-1">
          <section>
            <div class="cards-wrapper3">
              <div
                class="top_cards"
                style="margin-right: 10px; position: relative"
                v-for="electronics in topElectronics"
                :key="electronics.id"
              >
                <router-link
                  :to="'/m/merchant/' + electronics.Merchant_Id"
                  style="text-decoration: none; font-weight: bold"
                >
                  <div
                    class="top_disc_badge"
                    v-if="electronics.Merchant_Discount"
                  >
                    {{ electronics.Merchant_Discount }}
                  </div>
                  <div
                    class="top_merc_badge"
                    v-if="electronics.merchant_types.length > 0"
                  >
                    <span>
                      <img
                        src="@/assets/images/shopping-bag.png"
                        alt="“merchant-type-logo”"
                        height="10"
                        style="margin-right: 2px; margin-top: -2px"
                      />
                    </span>
                    <span
                      class="bg animated fadeInDown"
                      style="color: #000000"
                      v-for="type in electronics.merchant_types"
                      :key="type.id"
                      >{{ type.Type }}
                      <span
                        v-if="type != electronics.merchant_types.slice(-1)[0]"
                        style="padding-left: 2px"
                        >|</span
                      >
                    </span>
                  </div>
  
                  <img
                    :src="electronics.thumbnail.url"
                    loading="lazy"
                    style="width: 100%; text-align: center; border-radius: 16px"
                  />
                </router-link>
              </div>
            </div>
  
            <div class="cards-wrapper3-skeleton" v-if="LoadElectronics">
              <div class="card4">
                <div class="cover skeleton" style="margin-bottom: 10%"></div>
              </div>
              <div class="card4">
                <div class="cover skeleton" style="margin-bottom: 10%"></div>
              </div>
              <div class="card4">
                <div class="cover skeleton" style="margin-bottom: 10%"></div>
              </div>
            </div>
          </section>
        </div>
      </div>
  
      <!-- Top Fashion -->
      <div class="fashions">
        <div class="row mt-3">
          <div class="d-flex justify-content-between">
            <div class="sectionHead">Top Fashion</div>
            <router-link
              to="/m/category?cattype=fashion"
              style="text-decoration: none; font-weight: bold"
            >
              <p class="sectionSubs">View All</p>
            </router-link>
          </div>
        </div>
        <div class="fashion_body mt-1">
          <section>
            <div class="cards-wrapper3" v-if="showFashion">
              <div
                class="top_cards"
                style="margin-right: 10px; position: relative"
                v-for="fashion in topFashion"
                :key="fashion.id"
              >
                <div class="top_disc_badge" v-if="fashion.Merchant_Discount">
                  {{ fashion.Merchant_Discount }}
                </div>
                <div
                  class="top_merc_badge"
                  v-if="fashion.merchant_types.length > 0"
                >
                  <span>
                    <img
                      src="@/assets/images/shopping-bag.png"
                      alt="“merchant-type-logo”"
                      height="10"
                      style="margin-right: 2px; margin-top: -2px"
                    />
                  </span>
                  <span
                    class="bg animated fadeInDown"
                    style="color: #000000"
                    v-for="type in fashion.merchant_types"
                    :key="type.id"
                    >{{ type.Type }}
                    <span
                      v-if="type != fashion.merchant_types.slice(-1)[0]"
                      style="padding-left: 2px"
                      >|</span
                    >
                  </span>
                </div>
  
                <router-link
                  :to="'/m/merchant/' + fashion.merchant_id"
                  style="text-decoration: none; font-weight: bold"
                >
                  <img
                    :src="fashion.thumbnail.url"
                    loading="lazy"
                    style="width: 100%; text-align: center; border-radius: 16px"
                    :srcset="`
                    ${fashion.thumbnail.url}?image_process=resize,w_200 200w,
                    ${fashion.thumbnail.url}?image_process=resize,w_400 400w,
                    ${fashion.thumbnail.url}?image_process=resize,w_800 800w,
                    ${fashion.thumbnail.url}?image_process=resize,w_1200 1200w
                    `"
                   sizes="(max-width: 480px) 200px, (max-width: 768px) 400px, (max-width: 1024px) 800px, 1200px"
                  />
                </router-link>
              </div>
            </div>
  
            <div class="cards-wrapper3-skeleton" v-if="LoadFashion">
              <div class="card4">
                <div class="cover skeleton" style="margin-bottom: 10%"></div>
              </div>
              <div class="card4">
                <div class="cover skeleton" style="margin-bottom: 10%"></div>
              </div>
              <div class="card4">
                <div class="cover skeleton" style="margin-bottom: 10%"></div>
              </div>
            </div>
          </section>
        </div>
      </div>
  
      <!-- Top Life Style -->
      <div class="fashions">
        <div class="row mt-3">
          <div class="d-flex justify-content-between">
            <div class="sectionHead">Top Home & lifestyle</div>
            <router-link
              to="/m/category?cattype=lifestyle"
              style="text-decoration: none; font-weight: bold"
            >
              <p class="sectionSubs">View All</p>
            </router-link>
          </div>
        </div>
        <div class="fashion_body mt-1">
          <section>
            <div class="cards-wrapper3" v-if="showLifestyle">
              <div
                class="top_cards"
                style="margin-right: 10px; position: relative"
                v-for="lifestyleList in lifestyle"
                :key="lifestyleList.id"
              >
                <router-link
                  :to="'/m/merchant/' + lifestyleList.merchant_id"
                  style="text-decoration: none; font-weight: bold"
                >
                  <div
                    class="top_disc_badge"
                    v-if="lifestyleList.Merchant_Discount"
                  >
                    {{ lifestyleList.Merchant_Discount }}
                  </div>
                  <div
                    class="top_merc_badge"
                    v-if="lifestyleList.merchant_types.length > 0"
                  >
                    <span>
                      <img
                        src="@/assets/images/shopping-bag.png"
                        alt="“merchant-type-logo”"
                        height="10"
                        style="margin-right: 2px; margin-top: -2px"
                      />
                    </span>
                    <span
                      class="bg animated fadeInDown"
                      style="color: #000000"
                      v-for="type in lifestyleList.merchant_types"
                      :key="type.id"
                      >{{ type.Type }}
                      <span
                        v-if="type != lifestyleList.merchant_types.slice(-1)[0]"
                        style="padding-left: 2px"
                        >|</span
                      >
                    </span>
                  </div>
  
                  <img
                    :src="lifestyleList.thumbnail.url"
                    loading="lazy"
                    style="width: 100%; text-align: center; border-radius: 16px"
                    :srcset="`
                    ${lifestyleList.thumbnail.url}?image_process=resize,w_200 200w,
                    ${lifestyleList.thumbnail.url}?image_process=resize,w_400 400w,
                    ${lifestyleList.thumbnail.url}?image_process=resize,w_800 800w,
                    ${lifestyleList.thumbnail.url}?image_process=resize,w_1200 1200w
                    `"
                   sizes="(max-width: 480px) 200px, (max-width: 768px) 400px, (max-width: 1024px) 800px, 1200px"
                  />
                </router-link>
              </div>
            </div>
            <div class="cards-wrapper3-skeleton" v-if="LoadLifestyle">
              <div class="card4">
                <div class="cover skeleton" style="margin-bottom: 10%"></div>
              </div>
              <div class="card4">
                <div class="cover skeleton" style="margin-bottom: 10%"></div>
              </div>
              <div class="card4">
                <div class="cover skeleton" style="margin-bottom: 10%"></div>
              </div>
            </div>
          </section>
        </div>
      </div>
  
      <!-- Top Restaurants & Cafes  -->
      <div class="fashions">
        <div class="row mt-3">
          <div class="d-flex justify-content-between">
            <div class="sectionHead col-9" style="line-height: 1.1">
              Top Restaurants & Cafes
            </div>
            <router-link
              to="/m/category?cattype=kokofood"
              style="text-decoration: none; font-weight: bold"
            >
              <p class="sectionSubs">View All</p>
            </router-link>
          </div>
        </div>
        <div class="fashion_body mt-1">
          <section>
            <div class="cards-wrapper3" v-if="showRestaurants">
              <div
                class="top_cards"
                style="margin-right: 10px; position: relative"
                v-for="RestaurantsList in toprestaurants"
                :key="RestaurantsList.id"
              >
                <router-link
                  :to="'/m/merchant/' + RestaurantsList.merchant_id"
                  style="text-decoration: none; font-weight: bold"
                >
                  <div
                    class="top_disc_badge"
                    v-if="RestaurantsList.Merchant_Discount"
                  >
                    {{ RestaurantsList.Merchant_Discount }}
                  </div>
                  <div
                    class="top_merc_badge"
                    v-if="RestaurantsList.merchant_types.length > 0"
                  >
                    <span>
                      <img
                        src="@/assets/images/shopping-bag.png"
                        alt="“merchant-type-logo”"
                        height="10"
                        style="margin-right: 2px; margin-top: -2px"
                      />
                    </span>
                    <span
                      class="bg animated fadeInDown"
                      style="color: #000000"
                      v-for="type in RestaurantsList.merchant_types"
                      :key="type.id"
                      >{{ type.Type }}
                      <span
                        v-if="type != RestaurantsList.merchant_types.slice(-1)[0]"
                        style="padding-left: 2px"
                        >|</span
                      >
                    </span>
                  </div>
  
                  <img
                    :src="RestaurantsList.thumbnail.url"
                    loading="lazy"
                    style="width: 100%; text-align: center; border-radius: 16px"
                    :srcset="`
                    ${RestaurantsList.thumbnail.url}?image_process=resize,w_200 200w,
                    ${RestaurantsList.thumbnail.url}?image_process=resize,w_400 400w,
                    ${RestaurantsList.thumbnail.url}?image_process=resize,w_800 800w,
                    ${RestaurantsList.thumbnail.url}?image_process=resize,w_1200 1200w
                    `"
                   sizes="(max-width: 480px) 200px, (max-width: 768px) 400px, (max-width: 1024px) 800px, 1200px"
                  />
                </router-link>
              </div>
            </div>
            <div class="cards-wrapper3-skeleton" v-if="restaurantsLoad">
              <div class="card4">
                <div class="cover skeleton" style="margin-bottom: 10%"></div>
              </div>
              <div class="card4">
                <div class="cover skeleton" style="margin-bottom: 10%"></div>
              </div>
              <div class="card4">
                <div class="cover skeleton" style="margin-bottom: 10%"></div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  
    <div class="mt-3">
      <transition name="fade">
        <div id="pagetop" v-show="scY > 300" @click="toTop">
          <p class="sectionSubs" style="text-align: center">
            Move to Top
            <img
              src="https://prod-site-cdn.paykoko.com/O1CN01SeYObq1IAGBScjt8A_!!6000000000852-2-tps-512-512.png"
              alt=""
              width="20"
            />
          </p>
          <button
            class="close"
            @click="drawerVisible = true"
            style="display: none"
          >
            &#9587;
          </button>
        </div>
      </transition>
    </div>
  </template>
  
  <script>

  import { Splide, SplideSlide } from "@splidejs/vue-splide";
  import "@splidejs/splide/dist/css/themes/splide-skyblue.min.css";
  import "@splidejs/splide/dist/css/splide.min.css";
  import Strapi from "../services/strapi-services.js";
  
  import { INSTANT_SEARCH_INDEX_NAME } from "../components/search_utils/constants";
  import "instantsearch.css/themes/satellite-min.css";
  import { defineAsyncComponent } from 'vue';

  const strapi = new Strapi();
  
  export default {
    name: "MobDiscover",
    components: {
      Splide,
      SplideSlide,
      SearchDrawer: defineAsyncComponent(() =>import("../components/SearchDrawer.vue")),
    
    },
    setup() {
      const Leaderboard_BannerOptions = {
        type: "fade",
        rewind: true,
        autoplay: true,
        arrows: false,
        pagination: false,
      };
      const stripBanner_options = {
        type: "fade",
        rewind: true,
        autoplay: true,
        arrows: false,
        pagination: true,
        height: "100%",
      };
      const secondary_stripBanner_options = {
        type: "fade",
        rewind: true,
        autoplay: true,
        arrows: false,
        pagination: true,
        height: "100%",
      };
      const options = {
        type: "fade",
        rewind: true,
        height: "200px",
        autoplay: true,
        arrows: false,
        pagination: false,
      };
  
      return {
        options,
        stripBanner_options,
        Leaderboard_BannerOptions,
        secondary_stripBanner_options,
      };
    },
    data() {
      return {
        showPromotion: false,
        scTimer: 0,
        scY: 0,
  
        drawerVisible: false,
        showTopMercs: true,
        heroBannersList: [],
        stripBannerList: [],
        categoriesList: [],
        FeaturedStores: [],
        ProductList: [],
        showSkelton: true,
        showBanners: false,
        hotproducts: false,
        inspirationList: false,
        stripBanner: false,
        leadership_banner: false,
        onsiteSettings: [],
        InspirationalListThumbnails: [],
        homePageModules: [],
        firstLine: [],
        secondLine: [],
        topElectronics: [],
        topFashion: [],
        lifestyle: [],
        topbeauty: [],
        toprestaurants: [],
        secondaryStripBanners: [],
        homePageCategories: [],
        secondaryHeroBanners: [],
        hotDealsMerchants: [],
        firstClusterBanner: [],
        secondClusterBanner: [],
  
        // Define Modules
        KollektionModule: null,
  
        KokoFood: null,
        NewArrivalsModule: null,
        ShopOnline: null,
        Instore: null,
        Social: null,
  
        restaurantsLoad: true,
        showRestaurants: false,
  
        LoadBeauty: true,
        showBeautyList: false,
  
        showLifestyle: false,
        LoadLifestyle: true,
  
        showFashion: false,
        LoadFashion: true,
  
        showElectrnoics: false,
        LoadElectronics: true,
  
        showTopModuleLoader: true,
        showBottomModuleLoader: true,
  
        showBottomModuleData: false,
        showTopModuleData: false,
        // searchClient: algoliasearch(
        //   "JWPIR4IC05",
        //   "87c8bea112448d28be8ce7ee3e00bc61"
        // ),
        deals: [],
        showHotDeals: false,
        loadHotDeals: true,
  
        hotDealsIcon: "",
        featuredStoresIcon: "",
        firstClusterImage: "",
        secondClusterImage: "",
        hotproductsIcon: "",
  
        categoryFontColor: "",
        categoryBgColor: "",
        indexName: INSTANT_SEARCH_INDEX_NAME,
       
        showFilter: false,
        AllMerchants:[],
      };
    },
   
    methods: {

    // isLowBandwidth() {
    //   const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    //   return connection && ['2g', 'slow-2g'].includes(connection.effectiveType);
    // },
  
      updateShowFilter(value) {
        this.showFilter = value;
      },
      closeSearchDrawer(){
        this.drawerVisible=false
      },
      triggerFilter() {
        this.showFilter = !this.showFilter;
        console.log("filter is clicked", this.showFilter);
      },
      triggerDrawer() {
        this.drawerVisible = true;
        this.$nextTick(() => {
          this.$refs.search.focus();
        });
      },
      handleScroll: function () {
        if (this.scTimer) return;
        this.scTimer = setTimeout(() => {
          this.scY = window.scrollY;
          clearTimeout(this.scTimer);
          this.scTimer = 0;
        }, 100);
      },
      toTop: function () {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      },
  
      // New Caching Mechanism added to all image fetching functions, Primary functions refresh time frame is 5 mins and secondry functions are having 30mins 
      // Comments added for "getHerobanners" Method for identification purposes
      
      getHerobanners() {
          const cacheKey = "heroBannersCache"; 
          const cacheDuration = 1000 * 60 * 5; 
  
          // Retrieve cached data
          const cachedData = JSON.parse(localStorage.getItem(cacheKey));
          const now = Date.now();
  
          // Check if cached data exists and is still valid
          if (cachedData && now - cachedData.timestamp < cacheDuration) {
            // Use cached data
            this.heroBannersList = cachedData.data;
            this.showSkelton = false;
            this.showBanners = true;
            console.log("Using cached hero banners");
            return Promise.resolve(() => { }); // Exit early
          
          }
  
          // If no valid cache, fetch from API
          return strapi
            .getAllHeroBanners()
            .then((res) => {
              this.heroBannersList = res.data;
  
              // Store the fetched data in cache with a timestamp
              localStorage.setItem(
                cacheKey,
                JSON.stringify({ data: this.heroBannersList, timestamp: now })
              );
              console.log("Fetched hero banners from API and cached:", this.heroBannersList);
              this.showSkelton = false;
              this.showBanners = true;
            })
            .catch((error) => {
              console.error("Error fetching hero banners:", error);
            });
        },
  
  
      // Fetch Strip Banners
      getStripBanners() {
        const cacheKey = "stripBannersCache";
        const cacheDuration = 1000 * 60 * 5; 
  

        const cachedData = JSON.parse(localStorage.getItem(cacheKey));
        const now = Date.now();
  
       
        if (cachedData && now - cachedData.timestamp < cacheDuration) {
    
          this.stripBannerList = cachedData.data;
          this.stripBanner = true;
          console.log("Using cached strip banners");
          return; 
        }
  
        
        strapi
          .getAllStripBanners()
          .then((res) => {
            this.stripBannerList = res.data;
  
            
            localStorage.setItem(
              cacheKey,
              JSON.stringify({ data: this.stripBannerList, timestamp: now })
            );
            console.log("Fetched strip banners from API and cached:", this.stripBannerList);
            this.stripBanner = true;
          })
          .catch((error) => {
            console.error("Error fetching strip banners:", error);
          });
      },
  
  
  
      
  
      getFeaturedStores() {
        const cacheKey = "featuredStoresCache"; 
        const cacheDuration = 1000 * 60 * 5; 
  
        
        const cachedData = JSON.parse(localStorage.getItem(cacheKey));
        const now = Date.now();
  
        
        if (cachedData && now - cachedData.timestamp < cacheDuration) {
          
          this.FeaturedStores = cachedData.data;
          console.log("Using cached featured stores");
          return Promise.resolve(() => { });
        }
  
        
      return  strapi
          .getFeaturedStoresMerchants()
          .then((res) => {
            this.FeaturedStores = res.data;
  
            localStorage.setItem(
              cacheKey,
              JSON.stringify({ data: this.FeaturedStores, timestamp: now })
            );
            console.log("Fetched featured stores from API and cached:", this.FeaturedStores);
          })
          .catch((error) => {
            console.error("Error fetching featured stores:", error);
          });
      },
  
        getCategories() {
          const cacheKey = "categoriesCache"; 
          const cacheDuration = 1000 * 60 * 5; 
  
          
          const cachedData = JSON.parse(localStorage.getItem(cacheKey));
          const now = Date.now();
  
          
          if (cachedData && now - cachedData.timestamp < cacheDuration) {
            
            this.categoriesList = cachedData.data;
            console.log("Using cached categories");
            return Promise.resolve(() => { });
           // return;
          }
  
          
         return strapi
            .getAllCategories()
            .then((res) => {
              this.categoriesList = res.data;
  
              
              localStorage.setItem(
                cacheKey,
                JSON.stringify({ data: this.categoriesList, timestamp: now })
              );
              console.log("Fetched categories from API and cached:", this.categoriesList);
            })
            .catch((error) => {
              console.error("Error fetching categories:", error);
            });
        },
  
  
        getHotDeals() {
          const cacheKey = "hotDealsCache"; 
          const cacheDuration = 1000 * 60 * 5; 
  
          
          const cachedData = JSON.parse(localStorage.getItem(cacheKey));
          const now = Date.now();
  
          
          if (cachedData && now - cachedData.timestamp < cacheDuration) {
          
            this.hotDealsMerchants = cachedData.data;
            this.hotDealsMerchants.sort((a, b) => a.Rank - b.Rank); 
            this.showHotDeals = true;
            this.loadHotDeals = false;
            console.log("Using cached hot deals:", this.hotDealsMerchants);
            return;
          }
  
          
          strapi
            .getHotDealsMerchants()
            .then((res) => {
              this.hotDealsMerchants = res.data;
              this.hotDealsMerchants.sort((a, b) => a.Rank - b.Rank); 
              this.showHotDeals = true;
              this.loadHotDeals = false;
  
              
              localStorage.setItem(
                cacheKey,
                JSON.stringify({ data: this.hotDealsMerchants, timestamp: now })
              );
              console.log("Fetched hot deals from API and cached:", this.hotDealsMerchants);
            })
            .catch((error) => {
              console.error("Error fetching hot deals:", error);
            });
        },
  
  
        getAllProducts() {
          const cacheKey = "productsCache"; 
          const cacheDuration = 1000 * 60 * 5; 
  
          
          const cachedData = JSON.parse(localStorage.getItem(cacheKey));
          const now = Date.now();
  
          
          if (cachedData && now - cachedData.timestamp < cacheDuration) {
            
            this.products = cachedData.data;
            this.ProductList = this.products.slice(0, 6); 
            this.hotproducts = true;
            console.log("Using cached product list:", this.ProductList);
            return; 
          }
  
          
          strapi
            .getAllProductList()
            .then((res) => {
              this.products = res.data;
              this.ProductList = this.products.slice(0, 6); 
              this.hotproducts = true;
  
              
              localStorage.setItem(
                cacheKey,
                JSON.stringify({ data: this.products, timestamp: now })
              );
              console.log("Fetched product list from API and cached:", this.ProductList);
            })
            .catch((error) => {
              console.error("Error fetching product list:", error);
            });
        },
  
        getHomePageCategories() {
          const cacheKey = "homePageCategoriesCache"; 
          const cacheDuration = 1000 * 60 * 5; 
  
          
          const cachedData = JSON.parse(localStorage.getItem(cacheKey));
          const now = Date.now();
  
          
          const expectedCategoryOrder = [
            "women", "men", "electronics", "appliances", "lifestyle",
            "sports", "mobile", "grocery"
          ];
  
          
          if (cachedData && now - cachedData.timestamp < cacheDuration) {
            
            this.homePageCategories = cachedData.data;
  
            
            this.homePageCategories.sort(
              (a, b) => expectedCategoryOrder.indexOf(a.Slug) - expectedCategoryOrder.indexOf(b.Slug)
            );
  
            this.homePageCategoriesFilteredData = this.homePageCategories;
            console.log("Using cached home page categories:", this.homePageCategories);
            return; 
          }
  
          
          strapi
            .getHomePageCategoriesList()
            .then((res) => {
              this.homePageCategories = res.data;
  
              
              this.homePageCategories.sort(
                (a, b) => expectedCategoryOrder.indexOf(a.Slug) - expectedCategoryOrder.indexOf(b.Slug)
              );
  
              this.homePageCategoriesFilteredData = this.homePageCategories;
  
             
              localStorage.setItem(
                cacheKey,
                JSON.stringify({ data: this.homePageCategories, timestamp: now })
              );
              console.log("Fetched home page categories from API and cached:", this.homePageCategories);
            })
            .catch((error) => {
              console.error("Error fetching home page categories:", error);
            });
        },
  
  
  
        getInspirationalThumbnails() {
          const cacheKey = "inspirationalThumbnailsCache"; 
          const cacheDuration = 1000 * 60 * 5; 
  
          
          const cachedData = JSON.parse(localStorage.getItem(cacheKey));
          const now = Date.now();
  
          
          if (cachedData && now - cachedData.timestamp < cacheDuration) {
            
            this.InspirationalListThumbnails = cachedData.data;
            console.log("Using cached inspirational thumbnails:", this.InspirationalListThumbnails);
            return; 
          }
  
          
          strapi
            .getInspirationalListThumbnails()
            .then((res) => {
              this.InspirationalListThumbnails = res.data;
  
              localStorage.setItem(
                cacheKey,
                JSON.stringify({ data: this.InspirationalListThumbnails, timestamp: now })
              );
              console.log("Fetched inspirational thumbnails from API and cached:", this.InspirationalListThumbnails);
            })
            .catch((error) => {
              console.error("Error fetching inspirational thumbnails:", error);
            });
        },
  
  
      getSettings() {
        return strapi
          .getOnsiteSettings()
          .then((res) => {
            this.onsiteSettings = res.data[0];
            this.KollektionModule =
              this.onsiteSettings.HomePageModule_Kollektion.url;
            this.KokoFood = this.onsiteSettings.HomePageModule_KokoFood.url;
            this.NewArrivalsModule =
              this.onsiteSettings.HomePageModule_NewArrivals.url;
            this.ShopOnline = this.onsiteSettings.HomePageModule_ShopOnline.url;
            this.Instore = this.onsiteSettings.HomePageModule_InStore.url;
            this.Social = this.onsiteSettings.HomePageModule_Social.url;
            this.featuredStoresIcon =
              this.onsiteSettings.featured_stores_icon.url;
            this.hotDealsIcon = this.onsiteSettings.hot_deals_icon.url;
            this.hotproductsIcon = this.onsiteSettings.hot_products_icon.url;
  
            this.categoryFontColor = this.onsiteSettings.home_page_cat_font_color;
            this.categoryBgColor = this.onsiteSettings.home_page_cat_bg_color;
  
            this.showTopModuleLoader = false;
            this.showBottomModuleLoader = false;
            this.showBottomModuleData = true;
            this.showTopModuleData = true;
  
            if (this.onsiteSettings.hot_products_enable === true) {
              this.getAllProducts();
            } else {
              this.hotproducts = false;
            }
  
            if (this.onsiteSettings.strip_banner_enable === true) {
              this.getStripBanners();
            } else {
              this.stripBanner = false;
            }
            if (this.onsiteSettings.leaderboard_banner_enable === true) {
              this.leadership_banner = true;
            } else {
              this.leadership_banner = false;
            }
  
            if (this.onsiteSettings.inspirationalList_enable === true) {
              this.inspirationList = true;
            } else {
              this.inspirationList = false;
            }
  
            if (this.onsiteSettings.hot_deals_enable === true) {
              this.getHotDeals();
            } else {
              this.showHotDeals = false;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      },
  
  
  
  HomePageModules() {
    const cacheKey = "homePageModulesCache"; 
    const cacheDuration = 1000 * 60 * 5; 
  
    
    const cachedData = JSON.parse(localStorage.getItem(cacheKey));
    const now = Date.now();
  
    
    if (cachedData && now - cachedData.timestamp < cacheDuration) {
      
      this.homePageModules = cachedData.data;
      this.firstLine = this.homePageModules.slice(0, 4);
      this.secondLine = this.homePageModules.slice(3, 6);
      this.showTopModuleLoader = false;
      this.showBottomModuleLoader = false;
      this.showBottomModuleData = true;
      this.showTopModuleData = true;
      console.log("Using cached homepage modules:", this.homePageModules);
      return;
    }
  
    
    strapi
      .GetHomePageModules()
      .then((res) => {
        this.homePageModules = res.data;
        this.firstLine = this.homePageModules.slice(0, 4);
        this.secondLine = this.homePageModules.slice(3, 6);
        this.showTopModuleLoader = false;
        this.showBottomModuleLoader = false;
        this.showBottomModuleData = true;
        this.showTopModuleData = true;
  
        
        localStorage.setItem(
          cacheKey,
          JSON.stringify({ data: this.homePageModules, timestamp: now })
        );
        console.log("Fetched homepage modules from API and cached:", this.homePageModules);
      })
      .catch((error) => {
        console.error("Error fetching homepage modules:", error);
      });
  },
  
      getsecondaryStripBanner() {
        const cacheKey = "secondaryStripBannerCache";
        const cacheDuration = 1000 * 60 * 5; 
  
        
        const cachedData = JSON.parse(localStorage.getItem(cacheKey));
        const now = Date.now();
  
        if (cachedData && now - cachedData.timestamp < cacheDuration) {
          
          this.secondaryStripBanners = cachedData.data;
          console.log("Using cached secondary strip banners:", this.secondaryStripBanners);
          return;
        }
  
        
        strapi
          .getSecondaryStripBanners()
          .then((res) => {
            this.secondaryStripBanners = res.data;
  
            
            localStorage.setItem(
              cacheKey,
              JSON.stringify({ data: this.secondaryStripBanners, timestamp: now })
            );
            console.log("Fetched secondary strip banners from API and cached:", this.secondaryStripBanners);
          })
          .catch((error) => {
            console.error("Error fetching secondary strip banners:", error);
          });
      },
  
      getsecondaryHeroBanner() {
          const cacheKey = "secondaryHeroBannerCache"; 
          const cacheDuration = 1000 * 60 * 5; 
  
          
          const cachedData = JSON.parse(localStorage.getItem(cacheKey));
          const now = Date.now();
  
          if (cachedData && now - cachedData.timestamp < cacheDuration) {
            
            this.secondaryHeroBanners = cachedData.data;
            console.log("Using cached secondary hero banners:", this.secondaryHeroBanners);
            return; 
          }
  
          
          strapi
            .getSecondaryHeroBanners()
            .then((res) => {
              this.secondaryHeroBanners = res.data;
  
              
              localStorage.setItem(
                cacheKey,
                JSON.stringify({ data: this.secondaryHeroBanners, timestamp: now })
              );
              console.log("Fetched secondary hero banners from API and cached:", this.secondaryHeroBanners);
            })
            .catch((error) => {
              console.error("Error fetching secondary hero banners:", error);
            });
        },
  
  
      getFirstClusterBanner() {
        const cacheKey = "firstClusterBannerCache";
        const cacheDuration = 1000 * 60 * 5; 
  
        
        const cachedData = JSON.parse(localStorage.getItem(cacheKey));
        const now = Date.now();
  
        if (cachedData && now - cachedData.timestamp < cacheDuration) {
          
          this.firstClusterBanner = cachedData.data;
          this.firstClusterImage = this.firstClusterBanner.Banner_Image.url;
          console.log("Using cached first cluster banner:", this.firstClusterBanner);
          return;
        }
  
        
        strapi
          .getFirstClusterBanner()
          .then((res) => {
            this.firstClusterBanner = res.data[0];
            this.firstClusterImage = this.firstClusterBanner.Banner_Image.url;
  
            
            localStorage.setItem(
              cacheKey,
              JSON.stringify({ data: this.firstClusterBanner, timestamp: now })
            );
            console.log("Fetched first cluster banner from API and cached:", this.firstClusterBanner);
          })
          .catch((error) => {
            console.error("Error fetching first cluster banner:", error);
          });
      },
  
  
  
  
      getSecondClusterBanner() {
        const cacheKey = "secondClusterBannerCache"; 
        const cacheDuration = 1000 * 60 * 5; 
  
        
        const cachedData = JSON.parse(localStorage.getItem(cacheKey));
        const now = Date.now();
  
        
        if (cachedData && now - cachedData.timestamp < cacheDuration) {
          
          this.secondClusterBanner = cachedData.data;
          this.secondClusterImage = this.secondClusterBanner.Banner_Image.url;
          console.log("Using cached second cluster banner:", this.secondClusterBanner);
          return;
        }
  
        
        strapi
          .getSecondClusterBanner()
          .then((res) => {
            
            this.secondClusterBanner = res.data[0];
            this.secondClusterImage = this.secondClusterBanner.Banner_Image.url;
  
            
            localStorage.setItem(
              cacheKey,
              JSON.stringify({ data: this.secondClusterBanner, timestamp: now })
            );
            console.log("Fetched second cluster banner from API and cached:", this.secondClusterBanner);
          })
          .catch((error) => {
            console.error("Error fetching second cluster banner:", error);
          });
      },
  
  
      
  
      GetElectrnicsMerchants() {
        const cacheKey = "electronicsMerchantsCache"; 
        const cacheDuration = 1000 * 60 * 60; 
  
        
        const cachedData = JSON.parse(localStorage.getItem(cacheKey));
        const now = Date.now();
  
        if (cachedData && now - cachedData.timestamp < cacheDuration) {
          
          this.topElectronics = cachedData.data;
          this.showElectrnoics = true;
          this.LoadElectronics = false;
          console.log("Using cached electronics merchants:", this.topElectronics);
          return; 
        }
  
        
        strapi
          .GetElectronicsMerchantsList()
          .then((res) => {
            this.topElectronics = res.data;
            this.showElectrnoics = true;
            this.LoadElectronics = false;
  
            
            localStorage.setItem(
              cacheKey,
              JSON.stringify({ data: this.topElectronics, timestamp: now })
            );
            console.log("Fetched electronics merchants from API and cached:", this.topElectronics);
          })
          .catch((error) => {
            console.error("Error fetching electronics merchants:", error);
          });
      },
  
      GetFashionMerchants() {
          const cacheKey = "fashionMerchantsCache"; 
          const cacheDuration = 1000 * 60 * 60; 
  
          
          const cachedData = JSON.parse(localStorage.getItem(cacheKey));
          const now = Date.now();
  
          if (cachedData && now - cachedData.timestamp < cacheDuration) {
          
            this.topFashion = cachedData.data;
            this.showFashion = true;
            this.LoadFashion = false;
            console.log("Using cached fashion merchants:", this.topFashion);
            return;
          }
  
          
          strapi
            .GetFashionMerchantsList()
            .then((res) => {
              this.topFashion = res.data;
              this.showFashion = true;
              this.LoadFashion = false;
  
              
              localStorage.setItem(
                cacheKey,
                JSON.stringify({ data: this.topFashion, timestamp: now })
              );
              console.log("Fetched fashion merchants from API and cached:", this.topFashion);
            })
            .catch((error) => {
              console.error("Error fetching fashion merchants:", error);
            });
        },
  
        GetLifeStyleMerchants() {
          const cacheKey = "lifestyleMerchantsCache"; 
          const cacheDuration = 1000 * 60 * 60; 
  
          
          const cachedData = JSON.parse(localStorage.getItem(cacheKey));
          const now = Date.now();
  
          if (cachedData && now - cachedData.timestamp < cacheDuration) {
            
            this.lifestyle = cachedData.data;
            this.showLifestyle = true;
            this.LoadLifestyle = false;
            console.log("Using cached lifestyle merchants:", this.lifestyle);
            return; 
          }
  
          
          strapi
            .GetLifeStyleMerchantsList()
            .then((res) => {
              this.lifestyle = res.data;
              this.showLifestyle = true;
              this.LoadLifestyle = false;
  
              
              localStorage.setItem(
                cacheKey,
                JSON.stringify({ data: this.lifestyle, timestamp: now })
              );
              console.log("Fetched lifestyle merchants from API and cached:", this.lifestyle);
            })
            .catch((error) => {
              console.error("Error fetching lifestyle merchants:", error);
            });
        },
  
  GetBeautyMerchants() {
    const cacheKey = "beautyMerchantsCache"; 
    const cacheDuration = 1000 * 60 * 60; 
  
    
    const cachedData = JSON.parse(localStorage.getItem(cacheKey));
    const now = Date.now();
  
    if (cachedData && now - cachedData.timestamp < cacheDuration) {
      
      this.topbeauty = cachedData.data;
      this.showBeautyList = true;
      this.LoadBeauty = false;
      console.log("Using cached beauty merchants:", this.topbeauty);
      return; 
    }
  
    
    strapi
      .GetBeaytyMerchantsList()
      .then((res) => {
        this.topbeauty = res.data;
        this.showBeautyList = true;
        this.LoadBeauty = false;
  
        
        localStorage.setItem(
          cacheKey,
          JSON.stringify({ data: this.topbeauty, timestamp: now })
        );
        console.log("Fetched beauty merchants from API and cached:", this.topbeauty);
      })
      .catch((error) => {
        console.error("Error fetching beauty merchants:", error);
      });
  },
  
  
  GetRestaurantsMerchants() {
        const cacheKey = "restaurantsMerchantsCache"; 
        const cacheDuration = 1000 * 60 * 60; 
  
        
        const cachedData = JSON.parse(localStorage.getItem(cacheKey));
        const now = Date.now();
  
        if (cachedData && now - cachedData.timestamp < cacheDuration) {
          
          this.toprestaurants = cachedData.data;
          this.showRestaurants = true;
          this.restaurantsLoad = false;
          console.log("Using cached restaurant merchants:", this.toprestaurants);
          return; 
        }
  
        
        strapi
          .GetRestaurantMerchantsList()
          .then((res) => {
            this.toprestaurants = res.data;
            this.showRestaurants = true;
            this.restaurantsLoad = false;
  
            
            localStorage.setItem(
              cacheKey,
              JSON.stringify({ data: this.toprestaurants, timestamp: now })
            );
            console.log("Fetched restaurant merchants from API and cached:", this.toprestaurants);
          })
          .catch((error) => {
            console.error("Error fetching restaurant merchants:", error);
          });
      },
      
      async loadInitialData() {
        try {
          await Promise.all([this.getSettings(), this.getHerobanners(), this.getHomePageCategories(),this.HomePageModules(),this.getFeaturedStores()]);
          await Promise.all([
             this.getCategories(),
            //this.getFeaturedStores(),
            this.HomePageModules(),
            this.getInspirationalThumbnails(),
          ]);
        } catch (error) {
          console.error("Error loading initial data:", error);
        }
      },
  
      loadDeferredData() {
      //  Promise.all([
        this.GetElectrnicsMerchants();
        this.GetFashionMerchants();
        this.GetLifeStyleMerchants();
        this.GetBeautyMerchants();
        this.GetRestaurantsMerchants();
        this.getsecondaryStripBanner();
        this.getsecondaryHeroBanner();
        this.getFirstClusterBanner();
        this.getSecondClusterBanner();
      //  ])
      }
  

    },
  
    created() {
      document.title = "Buy Now Pay Later with Koko";
      
    },
    
    
    mounted() {
      const items = document.querySelectorAll('li.ais-InfiniteHits-item');
  
      // Iterate through each <li> element
      items.forEach(item => {
          // Find the button inside the current <li> element
          const button = item.querySelector('button');
          // Check if the button contains the text "Show more results"
          if (button && button.textContent.trim() === 'Show more results') {
              // Hide the button by setting its display property to "none"
              button.style.display = 'none';
          }
      });
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.toString() !== '') {
        
        const baseUrl = window.location.href.split('?')[0];
        window.history.replaceState({}, document.title, baseUrl); 
      }
      
      window.addEventListener("scroll", this.handleScroll);
  
      var countDownDate = new Date("July 28, 2022 00:00:00").getTime();
      var x = setInterval(function () {
        var now = new Date().getTime();
  
        var distance = countDownDate - now;
  
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
  
        document.getElementById("day").innerText = days;
        document.getElementById("hour").innerText = hours;
        document.getElementById("minute").innerText = minutes;
        document.getElementById("second").innerText = seconds;
  
        if (distance < 0) {
          clearInterval(x);
          document.getElementById("day").innerHTML = "--";
          document.getElementById("hour").innerHTML = "--";
          document.getElementById("minute").innerHTML = "--";
          document.getElementById("second").innerHTML = "--";
        }
      }, 1000);
  
      setInterval(function () {
        var x = document.getElementById("afterCountDown");
        var y = document.getElementById("beforeCountDown");
  
        var now = new Date().getTime();
        var finishDate = new Date("Mar 21, 2022 00:00:00").getTime();
        if (now < finishDate) {
          x.style.display = "none";
          y.style.display = "none";
        } else {
          clearInterval(x);
          x.style.display = "none";
          y.style.display = "none";
        }
      }, 500);
  
     this.loadInitialData();
      setTimeout(() => {
        this.loadDeferredData();
      }, 2000);

    //   if (this.isLowBandwidth()) {
    //     console.log("Low bandwidth detected. Adjusting requests...");
    //  }
     //Loads Initial and Deffered Data Acordingly

    //  this.loadInitialData();
    //  this.loadDeferredData();
    },
    
  };
  document.addEventListener("DOMContentLoaded", function() {
      hideButtonsWithPartialTitle();
  });
  
  function hideButtonsWithPartialTitle() {
      // Get all buttons
      const buttons = document.querySelectorAll('button');
  
      // Loop through each button
      buttons.forEach(button => {
          // Check if title contains the desired substring
          if (button.title.includes("Fill query with ")) {
              // Hide the button
              button.style.display = "none";
          }
      });
  }
  </script>
  
  <style scoped>
  .user-interface-magnifier {
    width: 18px;
    height: 18px;
    position: relative;
    overflow: hidden;
    flex-shrink: 0;
    z-index: 1;
  }
  .user-interface-magnifier-wrapper {
    height: 19px;
    width: 89px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 1px 0px 0px;
    box-sizing: border-box;
  }
  .pleaseTryAnother {
    position: relative;
    font-weight: 180;
    top: -190px;
    font-size: 15px;
  }
  .parentFrame {
    align-self: stretch;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 0px 10px;
    position: relative;
    gap: 118px 0px;
    text-align: center;
    font-size: 20px;
    color: var #000;
    font-family: Inter;
    top: 10px;
  }
  .noResultMessage {
    width: 91px;
    height: 91px;
    margin: 0 !important;
    top: 32px;
    left: 149px;
    overflow: hidden;
    flex-shrink: 0;
  }
  .sorryNoMatching {
    margin: 0;
    width: 245px;
    height: 30px;
    position: relative;
    font-size: inherit;
    font-weight: 700;
    font-family: inherit;
    display: inline-block;
    flex-shrink: 0;
    top: -100px;
  }
  
  .searchText {
    width: 100%;
    font-size: 12px;
    font-family: lato;
    margin-left: 5%;
    margin-top: 3%;
    color: #020202;
  }
  .searchBox {
    background-color: rgba(217, 217, 217, 1);
    width: 100%;
    height: 38px;
    border-radius: 1.625rem;
    box-shadow: 0 0px 15px rgb(0 0 0 / 6%);
  }
  
  .search_bar {
    border-radius: 16px !important;
    box-shadow: inset 0 1px 4px 0 rgb(255 255 255 / 0%) !important;
    font-size: 12px;
    font-family: lato;
  }
  a {
    color: #ababab00;
    text-decoration: underline;
  }
  .grayscale {
    filter: grayscale(100%);
  }
  .promotion_countdown_center {
    height: 7.8rem;
    /* background-color: #393939; */
    background-image: url("https://img.alicdn.com/imgextra/i3/O1CN01K6SDOx1koO7q81aEL_!!6000000004730-0-tps-1200-400.jpg");
    filter: grayscale(100%);
    background-size: cover;
    position: relative;
  }
  .promotion_countdown_center2 {
    height: 8.7rem;
    /* background-color: #393939; */
    background-image: url("https://img.alicdn.com/imgextra/i2/O1CN016tMzkp252qx0cVIjL_!!6000000007469-0-tps-1200-400.jpg");
    /* filter: grayscale(100%); */
    background-size: cover;
    position: relative;
  }
  .promotion_countdown_center4 {
    height: 4.8rem;
    /* background-color: #393939; */
    background-image: url("https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/sample/Homepage%20Leaderboard%20Strip%20Banner%20(Teaser)%20(3).jpg");
  
    background-size: cover;
    position: relative;
    border-radius: 16px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .discoverHead {
    /*font-family: Raleway;*/
    font-style: normal;
    font-size: 16px;
  }
  .discoverBoldHead {
    font-family: Raleway;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 24px;
  }
  
  .sectionHead {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    text-align: left;
    /* line-height: 42px; */
    /* margin-top: 20px; */
  
    color: #393939;
  }
  .sectionHead3 {
    font-family: raleway;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    text-align: left;
    /* line-height: 42px; */
    /* margin-top: 20px; */
    color: #8d8d8d;
    margin-left: 15px;
    padding-left: 11px;
  }
  
  .sectionHead2 {
    font-family: Lato;
    font-style: normal;
    font-weight: 600;
    font-size: 19px;
    text-align: center;
    /* line-height: 42px; */
    /* margin-top: 20px; */
    color: #393939;
    margin-left: 15px;
  }
  
  .sectionSubs {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    text-align: left;
    /* line-height: 42px; */
    /* margin-top: 25px; */
    padding-top: 10px;
    padding-right: 5px;
    margin-bottom: 0px;
    color: #393939;
  }
  
  .sectionBody {
    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 22px;
    padding-top: 0px;
    padding-bottom: 10px;
    color: #393939;
  
    opacity: 0.8;
  
    text-align: left;
  }
  
  .sectionBody2 {
    font-family: Raleway;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    padding-top: 0px;
    color: #393939;
    text-align: left;
  }
  
  .sectionBody3 {
    font-family: Raleway;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    padding-top: 0px;
    color: #393939;
    text-align: left;
  }
  img[alt]:-moz-broken {
    display: none;
  }
  .circle {
    position: relative;
    width: 80px;
    height: 80px;
  }
  .circle svg {
    fill: none;
    stroke: #8a3ab9;
    stroke-linecap: round;
    stroke-width: 3;
    stroke-dasharray: 1;
    stroke-dashoffset: 0;
    animation: stroke-draw 6s ease-out infinite alternate;
  }
  .circle img {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 70px;
    border-radius: 50%;
  }
  
  button.carousel__next {
    display: none !important;
  }
  
  .countdown {
    right: -6%;
    margin: 0%;
    display: flex;
    justify-content: center;
    align-items: left;
    /* font-family: "Righteous", cursive; */
    position: relative;
  }
  .countdown-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    color: #fff;
    font-size: 24px;
    border-radius: 10px;
    margin: 0 5px;
    min-width: 38px;
    min-height: 41px;
    z-index: 2;
    /* background-color: #fbc809; */
    color: #021ea3;
    font-family: "Lato";
    font-weight: 800;
  }
  .countdown-item span:nth-child(1) {
    height: 33px;
  }
  .countdown-item span:nth-child(2) {
    font-size: 16px;
  }
  .pulse {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 0;
    height: 0;
    opacity: 1;
    background-color: #fad5b8;
    border-radius: 50%;
    z-index: 1;
    animation: pluseAnimation 2s ease infinite;
  }
  @keyframes pluseAnimation {
    0% {
      width: 0;
      height: 0;
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      width: 500px;
      height: 500px;
      opacity: 0;
    }
  }
  
  /* font style */
  
  .neon {
    font-size: 20px;
    color: rgb(39, 38, 38);
    text-shadow: 0 0 5px #fff, 0 0 10px #fff, 0 0 20px #fff, 0 0 40px #0ff,
      0 0 80px #0ff, 0 0 90px rgb(20, 146, 196), 0 0 100px #0ff, 0 0 150px #0ff;
  }
  
  /* ------------------------------New app update styles -----------------------------------------------*/
  .category_body {
    margin-top: 2%;
    background-color: white;
    border-radius: 16px;
    /* box-shadow: rgb(0 0 0 / 20%) 0px 3px 10px; */
    height: 200px;
  }
  
  /* Hot deals Card Section */
  .cards-list {
    z-index: 0;
    width: 100%;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
  }
  
  .card {
    margin: 15px auto;
    width: 155px;
    height: 200px;
    border-radius: 16px;
    cursor: pointer;
    transition: 0.4s;
  }
  
  .card .card_image {
    width: inherit;
    height: inherit;
    border-radius: 16px;
  }
  
  .card .card_image img {
    width: inherit;
    height: inherit;
    border-radius: 16px;
    object-fit: cover;
  }
  
  .card .card_title {
    text-align: center;
    border-radius: 0px 0px 40px 40px;
    font-family: sans-serif;
    font-weight: bold;
    font-size: 30px;
    margin-top: -80px;
    height: 40px;
  }
  
  .card:hover {
    transform: scale(0.9, 0.9);
    box-shadow: 5px 5px 30px 15px rgba(216, 216, 216, 0.25),
      -5px -5px 30px 15px rgba(189, 188, 188, 0.22);
  }
  
  .title-white {
    color: white;
  }
  
  .title-black {
    color: black;
  }
  
  @media all and (max-width: 500px) {
    .card-list {
      /* On small screens, we are no longer using row direction but column */
      flex-direction: column;
    }
  }
  
  section {
    grid-template-columns: var(--page-margin) [center-start] 1fr [center-end] var(
        --page-margin
      );
  }
  section > * {
    grid-column: center;
  }
  /* For Categories */
  .cards-wrapper2 {
    /* grid-column: center-start/-1;
    display: grid;
    grid-auto-flow: column;  */
    gap: 2rem;
    /* overflow: auto; */
    padding-right: var(--page-margin);
    height: 200px;
  }
  .cards-wrapper2 .card2 {
    margin-top: 5%;
    /* display: grid;
    place-content: center; */
    font-size: 1.5rem;
    height: 60px;
    width: 72px;
    text-align: center;
    margin-left: 5%;
    /* box-shadow: rgb(0 0 0 / 20%) 0px 3px 10px; */
    border-radius: 50%;
  }
  
  .cluster-banner {
    grid-column: center-start/-1;
    display: grid;
    grid-auto-flow: column;
    gap: 1rem;
    overflow: auto;
    padding-right: var(--page-margin);
  }
  
  /* For Hot Deals */
  .cards-wrapper {
    grid-column: center-start/-1;
    display: grid;
    grid-auto-flow: column;
    gap: 1rem;
    overflow: auto;
    padding-right: var(--page-margin);
  }
  .cards-wrapper .card {
    display: grid;
    place-content: center;
    font-size: 1.5rem;
    box-shadow: rgb(0 0 0 / 20%) 0px 3px 10px;
    margin-left: 2%;
    text-align: center;
  }
  
  .cards-wrapper3 {
    grid-column: center-start/-1;
    display: grid;
    grid-auto-flow: column;
    /* gap: 1rem; */
    overflow: auto;
    padding-right: var(--page-margin);
  }
  
  .cards-wrapper3-skeleton {
    grid-column: center-start/-1;
    display: grid;
    grid-auto-flow: column;
    gap: 1rem;
    overflow: auto;
    padding-right: var(--page-margin);
  }
  
  .cards-wrapper3-skeleton .card4 {
    display: grid;
    place-content: center;
    font-size: 1.5rem;
    height: 150px;
    width: 130px;
    margin-top: 5%;
    margin-bottom: 8%;
  }
  
  .cards-wrapper3 .card3 {
    display: grid;
    place-content: center;
    background-color: #ffffff;
    font-size: 1.5rem;
    height: 162px;
    width: 120px;
    /* margin-top: 20%; */
    margin-bottom: 17%;
    box-shadow: rgb(0 0 0 / 20%) 0px 3px 10px;
  }
  
  .cards-wrapper3 .card5 {
    display: grid;
    place-content: center;
    font-size: 1.5rem;
    height: 162px;
    width: 130px;
  }
  
  .cards-wrapper3 .top_cards {
    place-content: center;
    font-size: 1.5rem;
    height: 162px;
    width: 130px;
  }
  
  .cards-wrapper3 .card4 {
    display: grid;
    place-content: center;
    font-size: 1.5rem;
    height: 162px;
    width: 130px;
    margin-top: 5%;
    margin-bottom: 8%;
  }
  
  .card {
    border: 0px solid rgba(0, 0, 0, 0.125) !important;
  }
  
  .hotdeals_body {
    background-color: #fbfbfb;
    border-radius: 16px;
    box-shadow: rgb(0 0 0 / 20%) 0px 3px 10px;
    margin-top: 2%;
  }
  
  .fetureStore_body {
    background-color: #e0efec;
    border-radius: 16px;
    height: 100%;
    margin-top: 3%;
    padding-right: 3%;
    padding-left: 3%;
  }
  
  .fashion_body {
    background-color: white;
    border-radius: 16px;
    /* margin-top: 2%; */
  }
  
  .strip_banner {
    box-shadow: rgb(0 0 0 / 20%) 0px 3px 10px;
    border-radius: 16px;
    margin-top: 5%;
  }
  body::-webkit-scrollbar-thumb {
    background-color: var(#ffffff);
    border-radius: 6px;
    border: 3px solid var(#ffffff);
  }
  
  .splide__pagination {
    display: none !important;
  }
  
  .fire {
    font-size: 7px;
    filter: blur(0.02em);
    -webkit-filter: blur(0.02em);
    /* margin: 3em auto 0 auto; */
    position: relative;
    width: 3em;
    height: 6em;
    margin-top: 8%;
    margin-left: -8%;
  }
  
  .snowIcon {
    font-size: 7px;
    filter: blur(0.02em);
    -webkit-filter: blur(0.02em);
    /* margin: 3em auto 0 auto; */
    position: relative;
    width: 3em;
    height: 6em;
    margin-top: 15%;
    margin-left: -20px;
    /* margin-left: -107%; */
  }
  
  .particle {
    animation: rise 1s ease-in infinite;
    background-image: radial-gradient(#f3d1b6 90%, rgba(255, 80, 0, 0) 20%);
    border-radius: 90%;
    mix-blend-mode: screen;
    opacity: 0;
    position: absolute;
    bottom: 0;
    width: 2em;
    height: 2em;
  }
  .particle:nth-of-type(1) {
    animation-delay: 0.6100158048s;
    left: calc((100% - 5em) * 0);
  }
  .particle:nth-of-type(2) {
    animation-delay: 0.5799353313s;
    left: calc((100% - 5em) * 0.02);
  }
  .particle:nth-of-type(3) {
    animation-delay: 0.8936248719s;
    left: calc((100% - 5em) * 0.04);
  }
  .particle:nth-of-type(4) {
    animation-delay: 0.4127927888s;
    left: calc((100% - 5em) * 0.06);
  }
  .particle:nth-of-type(5) {
    animation-delay: 0.0009726365s;
    left: calc((100% - 5em) * 0.08);
  }
  .particle:nth-of-type(6) {
    animation-delay: 0.1811240832s;
    left: calc((100% - 5em) * 0.1);
  }
  .particle:nth-of-type(7) {
    animation-delay: 0.6177806845s;
    left: calc((100% - 5em) * 0.12);
  }
  .particle:nth-of-type(8) {
    animation-delay: 0.2773669295s;
    left: calc((100% - 5em) * 0.14);
  }
  .particle:nth-of-type(9) {
    animation-delay: 0.6251633152s;
    left: calc((100% - 5em) * 0.16);
  }
  .particle:nth-of-type(10) {
    animation-delay: 0.4543637585s;
    left: calc((100% - 5em) * 0.18);
  }
  .particle:nth-of-type(11) {
    animation-delay: 0.6258631365s;
    left: calc((100% - 5em) * 0.2);
  }
  .particle:nth-of-type(12) {
    animation-delay: 0.6946101777s;
    left: calc((100% - 5em) * 0.22);
  }
  .particle:nth-of-type(13) {
    animation-delay: 0.2506582665s;
    left: calc((100% - 5em) * 0.24);
  }
  .particle:nth-of-type(14) {
    animation-delay: 0.0367427281s;
    left: calc((100% - 5em) * 0.26);
  }
  .particle:nth-of-type(15) {
    animation-delay: 0.4423082086s;
    left: calc((100% - 5em) * 0.28);
  }
  .particle:nth-of-type(16) {
    animation-delay: 0.8294541504s;
    left: calc((100% - 5em) * 0.3);
  }
  .particle:nth-of-type(17) {
    animation-delay: 0.9304027691s;
    left: calc((100% - 5em) * 0.32);
  }
  .particle:nth-of-type(18) {
    animation-delay: 0.9483728555s;
    left: calc((100% - 5em) * 0.34);
  }
  .particle:nth-of-type(19) {
    animation-delay: 0.3582526535s;
    left: calc((100% - 5em) * 0.36);
  }
  .particle:nth-of-type(20) {
    animation-delay: 0.9057962988s;
    left: calc((100% - 5em) * 0.38);
  }
  .particle:nth-of-type(21) {
    animation-delay: 0.6973261781s;
    left: calc((100% - 5em) * 0.4);
  }
  .particle:nth-of-type(22) {
    animation-delay: 0.5916468118s;
    left: calc((100% - 5em) * 0.42);
  }
  .particle:nth-of-type(23) {
    animation-delay: 0.085381591s;
    left: calc((100% - 5em) * 0.44);
  }
  .particle:nth-of-type(24) {
    animation-delay: 0.712338936s;
    left: calc((100% - 5em) * 0.46);
  }
  .particle:nth-of-type(25) {
    animation-delay: 0.1680887314s;
    left: calc((100% - 5em) * 0.48);
  }
  .particle:nth-of-type(26) {
    animation-delay: 0.998484262s;
    left: calc((100% - 5em) * 0.5);
  }
  .particle:nth-of-type(27) {
    animation-delay: 0.3304230313s;
    left: calc((100% - 5em) * 0.52);
  }
  .particle:nth-of-type(28) {
    animation-delay: 0.802367509s;
    left: calc((100% - 5em) * 0.54);
  }
  .particle:nth-of-type(29) {
    animation-delay: 0.2586418996s;
    left: calc((100% - 5em) * 0.56);
  }
  .particle:nth-of-type(30) {
    animation-delay: 0.7685352555s;
    left: calc((100% - 5em) * 0.58);
  }
  .particle:nth-of-type(31) {
    animation-delay: 0.1417751266s;
    left: calc((100% - 5em) * 0.6);
  }
  .particle:nth-of-type(32) {
    animation-delay: 0.6203800631s;
    left: calc((100% - 5em) * 0.62);
  }
  .particle:nth-of-type(33) {
    animation-delay: 0.837332091s;
    left: calc((100% - 5em) * 0.64);
  }
  .particle:nth-of-type(34) {
    animation-delay: 0.7119994436s;
    left: calc((100% - 5em) * 0.66);
  }
  .particle:nth-of-type(35) {
    animation-delay: 0.4775289984s;
    left: calc((100% - 5em) * 0.68);
  }
  .particle:nth-of-type(36) {
    animation-delay: 0.2275607856s;
    left: calc((100% - 5em) * 0.7);
  }
  .particle:nth-of-type(37) {
    animation-delay: 0.7890560921s;
    left: calc((100% - 5em) * 0.72);
  }
  .particle:nth-of-type(38) {
    animation-delay: 0.1199660733s;
    left: calc((100% - 5em) * 0.74);
  }
  .particle:nth-of-type(39) {
    animation-delay: 0.0406120382s;
    left: calc((100% - 5em) * 0.76);
  }
  .particle:nth-of-type(40) {
    animation-delay: 0.0430045334s;
    left: calc((100% - 5em) * 0.78);
  }
  .particle:nth-of-type(41) {
    animation-delay: 0.3300648282s;
    left: calc((100% - 5em) * 0.8);
  }
  .particle:nth-of-type(42) {
    animation-delay: 0.7392852201s;
    left: calc((100% - 5em) * 0.82);
  }
  .particle:nth-of-type(43) {
    animation-delay: 0.8794405918s;
    left: calc((100% - 5em) * 0.84);
  }
  .particle:nth-of-type(44) {
    animation-delay: 0.7891641385s;
    left: calc((100% - 5em) * 0.86);
  }
  .particle:nth-of-type(45) {
    animation-delay: 0.9553607145s;
    left: calc((100% - 5em) * 0.88);
  }
  .particle:nth-of-type(46) {
    animation-delay: 0.8156136618s;
    left: calc((100% - 5em) * 0.9);
  }
  .particle:nth-of-type(47) {
    animation-delay: 0.2940639401s;
    left: calc((100% - 5em) * 0.92);
  }
  .particle:nth-of-type(48) {
    animation-delay: 0.5249084859s;
    left: calc((100% - 5em) * 0.94);
  }
  .particle:nth-of-type(49) {
    animation-delay: 0.0815957741s;
    left: calc((100% - 5em) * 0.96);
  }
  .particle:nth-of-type(50) {
    animation-delay: 0.1906478323s;
    left: calc((100% - 5em) * 0.98);
  }
  
  @keyframes rise {
    from {
      opacity: 0;
      transform: translateY(0) scale(1);
    }
    25% {
      opacity: 1;
    }
    to {
      opacity: 0;
      transform: translateY(-10em) scale(0);
    }
  }
  html,
  body {
    height: 100%;
  }
  
  .wrapper {
    width: 100%;
    background: #f3f4f4;
    min-height: 100%;
    text-align: center;
  }
  
  .x1 {
    left: 5%;
    -webkit-transform: scale(0.9);
    -moz-transform: scale(0.9);
    transform: scale(0.9);
    opacity: 0.6;
    -webkit-animation: moveclouds 15s linear infinite,
      sideWays 4s ease-in-out infinite alternate;
    -moz-animation: moveclouds 15s linear infinite,
      sideWays 4s ease-in-out infinite alternate;
  }
  
  .x2 {
    left: 25%;
    -webkit-transform: scale(0.6);
    -moz-transform: scale(0.6);
    transform: scale(0.6);
    opacity: 0.9;
    -webkit-animation: moveclouds 25s linear infinite,
      sideWays 5s ease-in-out infinite alternate;
    -moz-animation: moveclouds 25s linear infinite,
      sideWays 5s ease-in-out infinite alternate;
  }
  .x3 {
    left: 55%;
    -webkit-transform: scale(0.8);
    -moz-transform: scale(0.8);
    transform: scale(0.8);
    opacity: 0.8;
    -webkit-animation: moveclouds 20s linear infinite,
      sideWays 4s ease-in-out infinite alternate;
    -moz-animation: moveclouds 20s linear infinite,
      sideWays 4s ease-in-out infinite alternate;
  }
  .x4 {
    left: 72%;
    -webkit-transform: scale(0.75);
    -moz-transform: scale(0.75);
    transform: scale(0.75);
    opacity: 0.9;
    -webkit-animation: moveclouds 18s linear infinite,
      sideWays 2s ease-in-out infinite alternate;
    -moz-animation: moveclouds 18s linear infinite,
      sideWays 0zs ease-in-out infinite alternate;
  }
  .x5 {
    left: 88%;
    -webkit-transform: scale(0.8);
    -moz-transform: scale(0.8);
    transform: scale(0.8);
    opacity: 0.3;
    -webkit-animation: moveclouds 7s linear infinite,
      sideWays 1s ease-in-out infinite alternate;
    -moz-animation: moveclouds 7s linear infinite,
      sideWays 1s ease-in-out infinite alternate;
  }
  .x6 {
    left: 33%;
    opacity: 1;
    -webkit-animation: moveclouds 2s linear infinite,
      swayWays 1s ease-in-out infinite alternate;
    animation: moveclouds 10s linear infinite,
      swayWays 9s ease-in-out infinite alternate;
  }
  
  @-webkit-keyframes moveclouds {
    0% {
      top: 500px;
    }
    100% {
      top: -500px;
    }
  }
  
  @keyframes moveclouds {
    0% {
      top: 500px;
    }
    100% {
      top: -500px;
    }
  }
  
  @-webkit-keyframes sideWays {
    0% {
      margin-left: 0px;
    }
    100% {
      margin-left: 50px;
    }
  }
  
  @keyframes sideWays {
    0% {
      margin-left: 0px;
    }
    100% {
      margin-left: 50px;
    }
  }
  
  @-keyframes swayWays {
    0% {
      transform: rotate(12deg);
      left: -0.3%;
    }
    33% {
      transform: rotate(-2deg);
      left: 0.7%;
    }
    100% {
      transform: rotate(0deg);
      left: -12%;
    }
  }
  
  /* //  HEART CODE */
  .altheart {
    background: url(http://static.indigoimages.ca/2016/shop/113439_img25_twotoneheart.png)
      no-repeat center;
    width: 24px;
    height: 21px;
    position: relative;
    display: block;
  }
  
  .heart {
    position: relative;
  }
  .heart:before,
  .heart:after {
    position: absolute;
    content: "";
    left: 18px;
    top: 0;
    width: 18px;
    height: 30px;
    background: #cc2022;
    -moz-border-radius: 20px 50% 0 0;
    border-radius: 30px 30px 0 0;
    -webkit-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    transform: rotate(-45deg);
    -webkit-transform-origin: 0 100%;
    -ms-transform-origin: 0 100%;
    transform-origin: 0 100%;
  }
  .heart:after {
    left: 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
    -webkit-transform-origin: 100% 100%;
    -ms-transform-origin: 100% 100%;
    transform-origin: 100% 100%;
  }
  
  div#app {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  div#app .search-wrapper {
    position: relative;
  }
  div#app .search-wrapper label {
    position: absolute;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.5);
    top: 14px;
    left: 12px;
    z-index: -1;
    transition: 0.15s all ease-in-out;
  }
  div#app .search-wrapper input {
    width: 361px;
    padding: 4px 12px;
    color: rgba(0, 0, 0, 0.7);
    border: 1px solid rgba(0, 0, 0, 0.12);
    transition: 0.15s all ease-in-out;
    background: white;
    margin-top: 2%;
    margin-bottom: 3%;
    border-radius: 12px;
  }
  div#app .search-wrapper input:focus {
    outline: none;
    transform: scale(1.05);
  }
  div#app .search-wrapper input:focus + label {
    font-size: 10px;
    transform: translateY(-24px) translateX(-12px);
  }
  div#app .search-wrapper input::-webkit-input-placeholder {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.5);
    font-weight: 100;
  }
  div#app .wrapper {
    display: flex;
    max-width: 444px;
    flex-wrap: wrap;
    padding-top: 12px;
  }
  div#app .card:hover {
    transform: scale(1.1);
  }
  div#app .card a {
    text-decoration: none;
    padding: 12px;
    color: #03a9f4;
    font-size: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  div#app .card a img {
    height: 100px;
  }
  div#app .card a small {
    font-size: 10px;
    padding: 4px;
  }
  div#app .hotpink {
    background: hotpink;
  }
  div#app .green {
    background: green;
  }
  div#app .box {
    width: 100px;
    height: 100px;
    border: 1px solid rgba(0, 0, 0, 0.12);
  }
  
  /* RIght side Drawer */
  
  .toggle {
    width: 100px;
    background: white;
    color: tomato;
    border: 0;
    padding: 5px;
    cursor: pointer;
  }
  
  .right-drawer {
    position: absolute;
    top: 0;
    right: 0;
    width: 0; /* initially */
    overflow: hidden;
    padding-left: 0; /* initially */
    border-left: 1px solid whitesmoke;
    background: white;
    z-index: 200;
    transition: all 0.2s;
    padding-top:10px;
    min-height: 2440px;
  }
  
  .drawer-mask {
    position: absolute;
    left: 0;
    top: 0;
    width: 5vw; /* initially */
    height: 550vw;
    background: rgb(145, 144, 144);
    opacity: 0.3;
    z-index: 199;
    transition: opacity 0.2s;
  }
  
  .label {
    font-size: 0.625rem;
    font-weight: 400;
    text-transform: uppercase;
    letter-spacing: +1.3px;
    margin-bottom: 1rem;
  }
  
  .searchBar {
    width: 98%;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 3%;
    margin-left: 1%;
  }
  
  .searchQuerySubmit {
    width: 3.5rem;
    height: 2.8rem;
    margin-left: -3.5rem;
    background: none;
    border: none;
    outline: none;
  }
  
  ::placeholder {
    opacity: 0.5; /* Firefox */
    font-family: raleway;
    font-style: normal;
    font-size: 12px;
  }
  
  /* close button */
  
  .close {
    position: absolute;
    right: 32px;
    top: 10px;
    width: 11px;
    opacity: 0.3;
  }
  .close:hover {
    opacity: 1;
  }
  .close:before,
  .close:after {
    position: absolute;
    left: 15px;
    content: " ";
    height: 20px;
    width: 2px;
    background-color: #333;
  }
  .close:before {
    transform: rotate(45deg);
  }
  .close:after {
    transform: rotate(-45deg);
  }
  
  /* Items Falling down CSS */
  /* .snowflake {
  }
  
  @-webkit-keyframes snowflakes-fall {
    0% {
      top: -10%;
    }
    100% {
      top: 100%;
    }
  }
  @-webkit-keyframes snowflakes-shake {
    0%,
    100% {
      -webkit-transform: translateX(0);
      transform: translateX(0);
    }
    50% {
      -webkit-transform: translateX(80px);
      transform: translateX(80px);
    }
  }
  @keyframes snowflakes-fall {
    0% {
      top: -10%;
    }
    100% {
      top: 100%;
    }
  }
  @keyframes snowflakes-shake {
    0%,
    100% {
      transform: translateX(0);
    }
    50% {
      transform: translateX(80px);
    }
  } */
  /* .snowflake {
    position: fixed;
    top: -10%;
    z-index: 9999;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: default;
    -webkit-animation-name: snowflakes-fall, snowflakes-shake;
    -webkit-animation-duration: 10s, 3s;
    -webkit-animation-timing-function: linear, ease-in-out;
    -webkit-animation-iteration-count: infinite, infinite;
    -webkit-animation-play-state: running, running;
    animation-name: snowflakes-fall, snowflakes-shake;
    animation-duration: 10s, 3s;
    animation-timing-function: linear, ease-in-out;
    animation-iteration-count: infinite, infinite;
    animation-play-state: running, running;
  } */
  .snowflake:nth-of-type(0) {
    left: 1%;
    -webkit-animation-delay: 0s, 0s;
    animation-delay: 0s, 0s;
  }
  .snowflake:nth-of-type(1) {
    left: 5%;
    -webkit-animation-delay: 1s, 1s;
    animation-delay: 1s, 1s;
  }
  .snowflake:nth-of-type(2) {
    left: 20%;
    -webkit-animation-delay: 6s, 0.5s;
    animation-delay: 6s, 0s;
  }
  .snowflake:nth-of-type(3) {
    left: 30%;
    -webkit-animation-delay: 4s, 2s;
    animation-delay: 4s, 2s;
  }
  .snowflake:nth-of-type(4) {
    left: 40%;
    -webkit-animation-delay: 2s, 2s;
    animation-delay: 2s, 2s;
  }
  .snowflake:nth-of-type(5) {
    left: 50%;
    -webkit-animation-delay: 8s, 3s;
    animation-delay: 8s, 3s;
  }
  .snowflake:nth-of-type(6) {
    left: 60%;
    -webkit-animation-delay: 6s, 2s;
    animation-delay: 6s, 2s;
  }
  .snowflake:nth-of-type(7) {
    left: 70%;
    -webkit-animation-delay: 2s, 1s;
    animation-delay: 1s, 1s;
  }
  .snowflake:nth-of-type(8) {
    left: 80%;
    -webkit-animation-delay: 1s, 0s;
    animation-delay: 1s, 0s;
  }
  .snowflake:nth-of-type(9) {
    left: 95%;
    -webkit-animation-delay: 3s, 1s;
    animation-delay: 3s, 1s;
  }
  .snowflake:nth-of-type(10) {
    left: 25%;
    -webkit-animation-delay: 2s, 0s;
    animation-delay: 2s, 0s;
  }
  .snowflake:nth-of-type(11) {
    left: 67%;
    -webkit-animation-delay: 4s, 2s;
    animation-delay: 4s, 2s;
  }
  .fashion_body2 {
    border-radius: 16px;
    box-shadow: rgb(0 0 0 / 20%) 0px 3px 10px;
    margin-top: 2%;
    position: relative;
  }
  
  /* Added The Badge  */
  .badge {
    position: absolute;
    left: 10px;
    top: 15px;
    text-transform: uppercase;
    font-size: 10px;
    font-weight: 500;
    background: #fafcfa;
    color: #000000;
    padding: 3px 10px;
    border-radius: 10px;
  }
  
  /* Skelton Loader Styles */
  @keyframes skeleton-animation {
    0% {
      right: 100%;
    }
  
    50% {
      right: -128px;
    }
  
    100% {
      right: 100%;
    }
  }
  
  .skeleton2 {
    overflow: hidden;
    width: 100%;
    height: 82px;
    display: grid;
    grid-template-columns: 100% 222px;
    grid-gap: 8px;
    position: relative;
    margin-bottom: 30px;
    border-radius: 15px;
  }
  
  .skeleton2:before {
    display: block;
    position: absolute;
    width: 100%;
    height: 82px;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0),
      #fff,
      rgba(255, 255, 255, 0)
    );
    content: "";
    -webkit-animation: skeleton-animation-43222382 2.25s infinite;
    animation: skeleton-animation-43222382 2.25s infinite;
  }
  
  .skeleton {
    overflow: hidden;
    width: 100%;
    height: 160px;
    display: grid;
    grid-template-columns: 100% 222px;
    grid-gap: 8px;
    position: relative;
    margin-bottom: 30px;
    border-radius: 15px;
  }
  
  .skeleton:before {
    display: block;
    position: absolute;
    width: 100%;
    height: 200px;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0),
      #fff,
      rgba(255, 255, 255, 0)
    );
    content: "";
    -webkit-animation: skeleton-animation-43222382 2.25s infinite;
    animation: skeleton-animation-43222382 2.25s infinite;
  }
  
  .skeleton .s-img {
    width: 100%;
    height: 100%;
    background: #eee;
    grid-row: 1 / 4;
  }
  
  .skeleton .s-line {
    height: 20px;
    background: #eee;
  }
  
  .skeleton .s-line.first {
    width: 100%;
  }
  
  .skeleton .s-line.second {
    width: 75%;
  }
  
  .skeleton .s-line.third {
    width: 50%;
  }
  
  /* Hot Products  */
  .wrapper {
    display: flex;
    max-width: 100%;
    flex-wrap: wrap;
    padding-top: 2px;
  }
  .card {
    box-shadow: rgb(0 0 0 / 20%) 0px 3px 10px;
    max-width: 100%;
    margin: 8px;
    border-radius: 16px;
    transition: 0.15s all ease-in-out;
  }
  .card:hover {
    transform: scale(1.1);
  }
  .card a {
    text-decoration: none;
    padding: 12px;
    color: #03a9f4;
    font-size: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .card a img {
  }
  .card a small {
    font-size: 10px;
    padding: 4px;
  }
  .hotpink {
    background: hotpink;
  }
  .green {
    background: green;
  }
  .box {
    width: 100px;
    height: 100px;
    border: 1px solid rgba(0, 0, 0, 0.12);
  }
  
  .card3 {
    display: grid;
    place-content: center;
    font-size: 1.5rem;
    height: 100%;
    width: 137px;
    margin-top: 17%;
    box-shadow: rgb(0 0 0 / 20%) 0px 3px 10px;
    border-radius: 16px;
    margin-left: 10%;
  }
  .mercText {
    font-family: Raleway;
    font-style: normal;
    font-weight: 200;
    font-size: 13px;
    color: #393939;
    margin-top: 5%;
    margin-left: 1%;
    margin-right: 1%;
  }
  
  .discount {
    position: relative;
    z-index: 100;
    box-shadow: rgb(0 0 0 / 20%) 0px 3px 10px;
    border-radius: 16px;
    margin-top: 0%;
    width: 147px;
  }
  .discount .discount-text {
    color: #fff;
    background: #242424;
    font-size: 13px;
    padding: 6px;
    font-weight: bold;
    font-family: Raleway;
    border-radius: 16px;
  }
  .discount .discount-text span {
    display: block;
    font-size: 11px;
    text-align: center;
  }
  
  .cover {
    border-radius: 8px;
    overflow: hidden;
  }
  .cover img {
    display: block;
    width: 100%;
    opacity: 0.95;
  }
  .skeleton {
    background: linear-gradient(
      90deg,
      hsl(210, 15%, 88%),
      hsl(210, 15%, 95%),
      hsl(210, 15%, 88%)
    );
    background-size: 200%;
    animation: loader 1s infinite reverse;
  }
  /* skeleton animation */
  @keyframes loader {
    from {
      background-position: -100% 0;
    }
    to {
      background-position: 100% 0;
    }
  }
  /* customizable snowflake styling */
  .snowflake {
    color: #ffffff;
    font-size: 1em;
    font-family: Arial;
    /* text-shadow: 0 0 1px #000; */
  }
  @-webkit-keyframes snowflakes-fall {
    0% {
      top: -10%;
    }
    100% {
      top: 100%;
    }
  }
  @-webkit-keyframes snowflakes-shake {
    0% {
      -webkit-transform: translateX(0px);
      transform: translateX(0px);
    }
    50% {
      -webkit-transform: translateX(80px);
      transform: translateX(80px);
    }
    100% {
      -webkit-transform: translateX(0px);
      transform: translateX(0px);
    }
  }
  @keyframes snowflakes-fall {
    0% {
      top: -10%;
    }
    100% {
      top: 100%;
    }
  }
  @keyframes snowflakes-shake {
    0% {
      transform: translateX(0px);
    }
    50% {
      transform: translateX(80px);
    }
    100% {
      transform: translateX(0px);
    }
  }
  .snowflake {
    position: fixed;
    top: -10%;
    z-index: 9999;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: default;
    -webkit-animation-name: snowflakes-fall, snowflakes-shake;
    -webkit-animation-duration: 10s, 3s;
    -webkit-animation-timing-function: linear, ease-in-out;
    -webkit-animation-iteration-count: infinite, infinite;
    -webkit-animation-play-state: running, running;
    animation-name: snowflakes-fall, snowflakes-shake;
    animation-duration: 10s, 3s;
    animation-timing-function: linear, ease-in-out;
    animation-iteration-count: infinite, infinite;
    animation-play-state: running, running;
  }
  .snowflake:nth-of-type(0) {
    left: 1%;
    -webkit-animation-delay: 0s, 0s;
    animation-delay: 0s, 0s;
  }
  .snowflake:nth-of-type(1) {
    left: 10%;
    -webkit-animation-delay: 1s, 1s;
    animation-delay: 1s, 1s;
  }
  .snowflake:nth-of-type(2) {
    left: 20%;
    -webkit-animation-delay: 6s, 0.5s;
    animation-delay: 6s, 0.5s;
  }
  .snowflake:nth-of-type(3) {
    left: 30%;
    -webkit-animation-delay: 4s, 2s;
    animation-delay: 4s, 2s;
  }
  .snowflake:nth-of-type(4) {
    left: 40%;
    -webkit-animation-delay: 2s, 2s;
    animation-delay: 2s, 2s;
  }
  .snowflake:nth-of-type(5) {
    left: 50%;
    -webkit-animation-delay: 8s, 3s;
    animation-delay: 8s, 3s;
  }
  .snowflake:nth-of-type(6) {
    left: 60%;
    -webkit-animation-delay: 6s, 2s;
    animation-delay: 6s, 2s;
  }
  .snowflake:nth-of-type(7) {
    left: 70%;
    -webkit-animation-delay: 2.5s, 1s;
    animation-delay: 2.5s, 1s;
  }
  .snowflake:nth-of-type(8) {
    left: 80%;
    -webkit-animation-delay: 1s, 0s;
    animation-delay: 1s, 0s;
  }
  .snowflake:nth-of-type(9) {
    left: 90%;
    -webkit-animation-delay: 3s, 1.5s;
    animation-delay: 3s, 1.5s;
  }
  
  .product-card {
    width: auto;
    position: relative;
    /* box-shadow: 0 3px 10px rgb(0 0 0 / 20%); */
    background: #fafafa;
    border-radius: 10px;
    margin-top: 5%;
    margin-bottom: 1%;
  }
  
  .badge3 {
    position: absolute;
    left: 5px;
    bottom: 15px;
    font-size: 9px;
    font-weight: 500;
    background: #ffffff;
    color: #000000;
    padding: 1px 5px;
    margin-right: 15px;
    border-radius: 10px;
  }
  
  .bg {
    display: inline-block;
    color: #000000;
    background: transparent;
    padding: 2px;
    border-radius: 50px;
    font-size: 9px;
    font-weight: lighter;
  }
  
  .cat-item {
    display: inline-block;
    color: #000000;
    border-radius: 30px;
    margin-right: 10px;
    padding: 10px 15px 10px 15px;
    font-size: 14px;
  }
  
  .cat-list {
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    display: inherit;
    height: 50px;
    background-color: transparent;
    border-radius: 0%;
    /* padding-top: 2%; */
    box-shadow: none;
    padding-right: 2%;
    padding-left: 2%;
    margin-bottom: 0px;
    margin-top: 5px;
  }
  .cat-item-text {
    text-decoration: none;
  }
  
  .cluster1-badge {
    position: absolute;
    left: 10px;
    top: 15px;
    font-size: 40px;
    font-weight: bold;
    color: #ffffff;
    padding-left: 5px;
    border-radius: 10px;
    line-height: 0.9;
    width: 80px;
  }
  
  .cluster2-badge {
    position: absolute;
    left: 5px;
    bottom: 10px;
    font-size: 20px;
    font-weight: bold;
    color: #ffffff;
    padding: 3px 10px;
    border-radius: 20px;
    line-height: 1.2;
  }
  
  /* new cluster  */
  .container_cluster {
    position: relative;
    width: 100%;
    height: 200px;
  }
  .cluster_background_image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .cluster_icon {
    bottom: 15px;
    right: 15px;
    position: absolute;
    object-fit: cover;
  }
  
  .top_disc_badge {
    position: absolute;
    left: 5px;
    top: 10px;
    font-size: 10px;
    background: #fafcfa;
    color: #000000;
    padding: 1px 10px;
    border-radius: 10px;
    font-weight: 500;
  }
  
  .top_merc_badge {
    position: absolute;
    left: 5px;
    bottom: 10px;
    font-size: 9px;
    background: #ffffff;
    color: #000000;
    padding: 1px 10px;
    margin-right: 5px;
    border-radius: 10px;
  }
  
  .cluster_row {
    --bs-gutter-x: 0.9rem !important;
  }
  
  .module_row {
    --bs-gutter-x: 0.9rem !important;
  }
  </style>